{
  "about.blocks": "Serwery moderowane",
  "about.contact": "Kontakt:",
  "about.default_locale": "Domyślny",
  "about.disclaimer": "Mastodon to wolne oprogramowanie o otwartym kodzie źródłowym, będące znakiem towarowym Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Powód niedostępny",
  "about.domain_blocks.preamble": "Domyślnie Mastodon pozwala ci przeglądać i reagować na treści od innych użytkowników z jakiegokolwiek serwera w fediwersum. Poniżej znajduje się lista wyjątków, które zostały stworzone na tym konkretnym serwerze.",
  "about.domain_blocks.silenced.explanation": "Zazwyczaj nie zobaczysz profili i treści z tego serwera, chyba że wyraźnie go poszukasz lub zdecydujesz się go obserwować.",
  "about.domain_blocks.silenced.title": "Ograniczone",
  "about.domain_blocks.suspended.explanation": "Żadne dane z tego serwera nie będą przetwarzane, przechowywane lub wymieniane, co uniemożliwia jakąkolwiek interakcję lub komunikację z użytkownikami z tego serwera.",
  "about.domain_blocks.suspended.title": "Zawieszono",
  "about.language_label": "Język",
  "about.not_available": "Ta informacja nie została udostępniona na tym serwerze.",
  "about.powered_by": "Zdecentralizowane media społecznościowe napędzane przez {mastodon}",
  "about.rules": "Regulamin serwera",
  "account.account_note_header": "Notatka osobista",
  "account.activity": "Aktywność",
  "account.add_note": "Dodaj notatkę osobistą",
  "account.add_or_remove_from_list": "Dodaj lub usuń z list",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Zablokowane",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "Zablokowana domena",
  "account.badges.group": "Grupa",
  "account.badges.muted": "Wyciszono",
  "account.badges.muted_until": "Wyciszono do {until}",
  "account.block": "Blokuj @{name}",
  "account.block_domain": "Blokuj wszystko z {domain}",
  "account.block_short": "Zablokuj",
  "account.blocked": "Zablokowano",
  "account.cancel_follow_request": "Nie obserwuj",
  "account.copy": "Skopiuj link do profilu",
  "account.direct": "Napisz bezpośrednio do @{name}",
  "account.disable_notifications": "Przestań powiadamiać mnie o postach użytkownika @{name}",
  "account.edit_note": "Edytuj notatkę osobistą",
  "account.edit_profile": "Edytuj profil",
  "account.edit_profile_short": "Edytuj",
  "account.enable_notifications": "Powiadamiaj mnie o postach użytkownika @{name}",
  "account.endorse": "Wyróżnij na profilu",
  "account.familiar_followers_many": "To konto jest obserwowane przez {name1}, {name2} i {othersCount, plural, one {jedną inną znaną ci osobę} few {# inne znane ci osoby} many {# innych znanych ci osób} other {# innych znanych ci osób}}",
  "account.familiar_followers_one": "Konto jest obserwowane przez: {name1}",
  "account.familiar_followers_two": "Konto jest obserwowane przez: {name1} i {name2}",
  "account.featured": "Wyróżnione",
  "account.featured.accounts": "Profile",
  "account.featured.collections": "Kolekcje",
  "account.featured.new_collection": "Nowa kolekcja",
  "account.field_overflow": "Pokaż całą zawartość",
  "account.filters.all": "Wszystkie aktywności",
  "account.filters.boosts_toggle": "Pokaż podbicia",
  "account.filters.posts_boosts": "Posty i podbicia",
  "account.filters.posts_only": "Posty",
  "account.filters.posts_replies": "Posty i odpowiedzi",
  "account.filters.replies_toggle": "Pokaż odpowiedzi",
  "account.follow": "Obserwuj",
  "account.follow_back": "Również obserwuj",
  "account.follow_back_short": "Również obserwuj",
  "account.follow_request": "Poproś o zgodę na obserwowanie",
  "account.follow_request_cancel": "Anuluj",
  "account.follow_request_cancel_short": "Anuluj",
  "account.follow_request_short": "Poproś",
  "account.followers": "Obserwujący",
  "account.followers.empty": "Nikt jeszcze nie obserwuje tego użytkownika.",
  "account.followers_counter": "{count, plural, one {{counter} obserwujący} few {{counter} obserwujących} many {{counter} obserwujących} other {{counter} obserwujących}}",
  "account.followers_you_know_counter": "znasz {counter}",
  "account.following": "Obserwowani",
  "account.following_counter": "{count, plural, one {{counter} obserwowany} few {{counter} obserwowanych} many {{counter} obserwowanych} other {{counter} obserwowanych}}",
  "account.follows.empty": "Ten użytkownik nie obserwuje jeszcze nikogo.",
  "account.follows_you": "Obserwuje cię",
  "account.go_to_profile": "Przejdź do profilu",
  "account.hide_reblogs": "Ukryj podbicia od @{name}",
  "account.in_memoriam": "Ku pamięci.",
  "account.join_modal.day": "Dzień",
  "account.join_modal.me": "Dołączyłeś(aś) na {server}",
  "account.join_modal.me_anniversary": "Happy Fediversary! Dołączyłeś(aś) na {server}",
  "account.join_modal.me_today": "To Twój pierwszy dzień na {server}!",
  "account.join_modal.other": "Użytkownik {name} dołączył na serwer {server} w dniu",
  "account.join_modal.other_today": "To jest pierwszy dzień użytkownika {name} na serwerze {server}!",
  "account.join_modal.share.celebrate": "Udostępnij uroczysty post",
  "account.join_modal.share.intro": "Udostępnij post wprowadzający",
  "account.join_modal.share.welcome": "Udostępnij post powitalny",
  "account.join_modal.years": "{number, plural, one {rok} few {lata} other {lat}}",
  "account.joined_short": "Dołączył(a)",
  "account.languages": "Zmień subskrybowane języki",
  "account.last_active": "Ostatnia aktywność",
  "account.link_verified_on": "Własność tego odnośnika została potwierdzona {date}",
  "account.locked_info": "To konto jest prywatne. Właściciel ręcznie wybiera kto może go obserwować.",
  "account.media": "Multimedia",
  "account.mention": "Wspomnij o @{name}",
  "account.menu.add_to_collection": "Dodaj do kolekcji…",
  "account.menu.add_to_list": "Dodaj do listy…",
  "account.menu.block": "Zablokuj konto",
  "account.menu.block_domain": "Zablokuj {domain}",
  "account.menu.copied": "Skopiowano link do konta do schowka",
  "account.menu.copy": "Skopiuj link",
  "account.menu.direct": "Prywatna wzmianka",
  "account.menu.hide_reblogs": "Ukrywaj podbicia na osi czasu",
  "account.menu.mention": "Wzmianka",
  "account.menu.mute": "Wycisz konta",
  "account.menu.note.description": "Widoczne tylko dla Ciebie",
  "account.menu.open_original_page": "Zobacz na {domain}",
  "account.menu.remove_follower": "Usuń obserwującego",
  "account.menu.report": "Zgłoś konto",
  "account.menu.share": "Udostępnij...",
  "account.menu.show_reblogs": "Pokazuj podbicia na osi czasu",
  "account.menu.unblock": "Odblokuj konto",
  "account.menu.unblock_domain": "Odblokuj {domain}",
  "account.menu.unmute": "Cofnij wyciszenie konta",
  "account.moved_to": "{name} jako swoje nowe konto wskazał/a:",
  "account.mute": "Wycisz @{name}",
  "account.mute_notifications_short": "Wycisz powiadomienia",
  "account.mute_short": "Wycisz",
  "account.muted": "Wyciszony",
  "account.mutual": "Obserwujecie się wzajemnie",
  "account.name.copy": "Kopiuj odnośnik",
  "account.name.help.domain": "{domain} to serwer, na którym znajduje się profil i posty tego użytkownika.",
  "account.name.help.domain_self": "{domain} to Twój serwer, na którym znajduje się Twój profil i posty.",
  "account.name.help.footer": "Tak samo jak możesz wysyłać e-maile do osób korzystających z różnych dostawców poczty, możesz wchodzić w interakcje z osobami na innych serwerach Mastodona oraz z każdym, kto korzysta z innych aplikacji Fediwersum.",
  "account.name.help.header": "Identyfikator jest jak adres e-mail",
  "account.name.help.username": "{username} to nazwa użytkownika tego konta na jego serwerze. Ktoś na innym serwerze może mieć taką samą nazwę użytkownika.",
  "account.name.help.username_self": "{username} to Twoja nazwa użytkownika na tym serwerze. Ktoś na innym serwerze może mieć taką samą nazwę użytkownika.",
  "account.name_info": "Co to oznacza?",
  "account.no_bio": "Brak opisu.",
  "account.node_modal.callout": "Notatki osobiste są widoczne tylko dla Ciebie.",
  "account.node_modal.edit_title": "Edytuj notatkę osobistą",
  "account.node_modal.error_unknown": "Nie można zapisać notatki",
  "account.node_modal.field_label": "Notatka osobista",
  "account.node_modal.save": "Zapisz",
  "account.node_modal.title": "Dodaj notatkę osobistą",
  "account.note.edit_button": "Edytuj",
  "account.note.title": "Notatka osobista (widoczna tylko dla Ciebie)",
  "account.open_original_page": "Otwórz stronę oryginalną",
  "account.pending": "Oczekuje",
  "account.posts": "Posty",
  "account.remove_from_followers": "Usuń {name} z obserwujących",
  "account.report": "Zgłoś @{name}",
  "account.requested_follow": "{name} chce cię obserwować",
  "account.share": "Udostępnij profil @{name}",
  "account.show_reblogs": "Pokazuj podbicia od @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} post} few {{counter} posty} many {{counter} postów} other {{counter} postów}}",
  "account.timeline.pinned": "Przypięte",
  "account.timeline.pinned.view_all": "Zobacz wszystkie przypięte posty",
  "account.unblock": "Odblokuj @{name}",
  "account.unblock_domain": "Odblokuj domenę {domain}",
  "account.unblock_domain_short": "Odblokuj",
  "account.unblock_short": "Odblokuj",
  "account.unendorse": "Nie wyświetlaj w profilu",
  "account.unfollow": "Nie obserwuj",
  "account.unmute": "Nie wyciszaj @{name}",
  "account.unmute_notifications_short": "Nie wyciszaj powiadomień",
  "account.unmute_short": "Nie wyciszaj",
  "account_edit.advanced_settings.bot_hint": "To konto wykonuje głównie zautomatyzowane działania i może nie być monitorowane",
  "account_edit.advanced_settings.bot_label": "Konto prowadzone przez bota",
  "account_edit.advanced_settings.title": "Ustawienia zaawansowane",
  "account_edit.bio.add_label": "Szczegóły profilu",
  "account_edit.bio.edit_label": "Edytuj szczegóły profilu",
  "account_edit.bio.placeholder": "Dodaj krótkie wprowadzenie, aby pomóc innym zidentyfikować cię.",
  "account_edit.bio.title": "Opis",
  "account_edit.bio_modal.add_title": "Szczegóły profilu",
  "account_edit.bio_modal.edit_title": "Edytuj szczegóły profilu",
  "account_edit.column_button": "Gotowe",
  "account_edit.column_title": "Edytuj profil",
  "account_edit.custom_fields.add_label": "Dodaj pole",
  "account_edit.custom_fields.edit_label": "Edytuj pole",
  "account_edit.custom_fields.placeholder": "Dodaj swoje zaimki, linki zewnętrzne lub cokolwiek innego, które chcesz udostępnić.",
  "account_edit.custom_fields.reorder_button": "Zmień kolejność pól",
  "account_edit.custom_fields.tip_content": "Możesz z łatwością zwiększyć wiarygodność swojego konta Mastodon poprzez weryfikację linków do wszelkich stron internetowych, które posiadasz.",
  "account_edit.custom_fields.tip_title": "Wskazówka: Dodawanie zweryfikowanych linków",
  "account_edit.custom_fields.title": "Pola niestandardowe",
  "account_edit.custom_fields.verified_hint": "Jak dodać zweryfikowany link?",
  "account_edit.display_name.add_label": "Dodaj nazwę wyświetlaną",
  "account_edit.display_name.edit_label": "Edytuj nazwę wyświetlaną",
  "account_edit.display_name.placeholder": "Twoja nazwa wyświetlana to jak Twoja nazwa pojawia się na Twoim profilu i na osiach czasu.",
  "account_edit.display_name.title": "Nazwa wyświetlana",
  "account_edit.featured_hashtags.edit_label": "Dodaj hashtagi",
  "account_edit.featured_hashtags.placeholder": "Pomóż innym zidentyfikować i mieć szybki dostęp do Twoich ulubionych tematów.",
  "account_edit.featured_hashtags.title": "Wyróżnione hashtagi",
  "account_edit.field_actions.delete": "Usuń pole",
  "account_edit.field_actions.edit": "Edytuj pole",
  "account_edit.field_delete_modal.confirm": "Czy na pewno chcesz usunąć to pole niestandardowe? Tej czynności nie można cofnąć.",
  "account_edit.field_delete_modal.delete_button": "Usuń",
  "account_edit.field_delete_modal.title": "Usuń pole niestandardowe?",
  "account_edit.field_edit_modal.add_title": "Dodaj pole niestandardowe",
  "account_edit.field_edit_modal.discard_confirm": "Odrzuć",
  "account_edit.field_edit_modal.discard_message": "Masz niezapisane zmiany. Czy na pewno chcesz je odrzucić?",
  "account_edit.field_edit_modal.edit_title": "Edytuj dodatkowe pole",
  "account_edit.field_edit_modal.length_warning": "Przekroczono limit zalecanych znaków. Użytkownicy mobilni mogą nie widzieć Twojego pola w całości.",
  "account_edit.field_edit_modal.name_hint": "Np. Strona osobista",
  "account_edit.field_edit_modal.name_label": "Etykieta",
  "account_edit.field_edit_modal.url_warning": "Aby dodać odnośnik, proszę dodać protokół {protocol} na początku. ",
  "account_edit.field_edit_modal.value_hint": "Np. \"https://example.me\"",
  "account_edit.field_edit_modal.value_label": "Wartość",
  "account_edit.field_reorder_modal.handle_label": "Przeciągnij pole \"{item}\"",
  "account_edit.image_alt_modal.add_title": "Dodaj tekst alternatywny",
  "account_edit.image_alt_modal.details_title": "Wskazówki: Tekst alternatywny dla zdjęć profilowych",
  "account_edit.image_alt_modal.edit_title": "Edytuj tekst alternatywny",
  "account_edit.image_alt_modal.text_hint": "Tekst alternatywny pomaga użytkownikom czytników ekranu zrozumieć twoją treść.",
  "account_edit.image_alt_modal.text_label": "Tekst alternatywny",
  "account_edit.image_delete_modal.confirm": "Czy na pewno chcesz usunąć ten obraz? Tej czynności nie można cofnąć.",
  "account_edit.image_delete_modal.delete_button": "Usuń",
  "account_edit.image_delete_modal.title": "Usunąć obraz?",
  "account_edit.image_edit.add_button": "Dodaj obraz",
  "account_edit.image_edit.alt_add_button": "Dodaj tekst alternatywny",
  "account_edit.image_edit.alt_edit_button": "Dodaj tekst alternatywny",
  "account_edit.image_edit.remove_button": "Usuń obraz",
  "account_edit.image_edit.replace_button": "Zastąp obraz",
  "account_edit.item_list.delete": "Usuń {name}",
  "account_edit.item_list.edit": "Edytuj {name}",
  "account_edit.name_modal.add_title": "Dodaj nazwę wyświetlaną",
  "account_edit.name_modal.edit_title": "Edytuj nazwę wyświetlaną",
  "account_edit.profile_tab.button_label": "Dostosuj",
  "account_edit.profile_tab.hint.description": "Te ustawienia wpływają na to, co użytkownicy widzą na {server} w oficjalnych aplikacjach, ale mogą nie obowiązywać na innych serwerach i w aplikacjach zewnętrznych.",
  "account_edit.profile_tab.hint.title": "Wyświetlanie może się różnić",
  "account_edit.profile_tab.show_featured.description": "\"Wyróżnione\" to opcjonalna zakładka, na której możesz wyświetlać inne konta.",
  "account_edit.profile_tab.show_featured.title": "Pokaż zakładkę \"Wyróżnione\"",
  "account_edit.profile_tab.show_media.description": "\"Multimedia\" jest opcjonalną zakładką, która wyświetla Twoje posty zawierające zdjęcia lub wideo.",
  "account_edit.profile_tab.show_media.title": "Pokaż zakładkę \"Multimedia\"",
  "account_edit.profile_tab.show_media_replies.description": "Po włączeniu zakładka Multimedia pokazuje zarówno Twoje posty, jak i odpowiedzi na posty innych osób.",
  "account_edit.profile_tab.show_media_replies.title": "Uwzględniaj odpowiedzi w zakładce \"Multimedia\"",
  "account_edit.profile_tab.show_relations.description": "Pokazuje innym użytkownikom konta, które obserwujesz oraz Twoich obserwujących w Twoim profilu. Inni użytkownicy nadal będą mogli zobaczyć, czy ich obserwujesz.",
  "account_edit.profile_tab.show_relations.title": "Pokaż \"Obserwujących\" i \"Obserwowanych\"",
  "account_edit.profile_tab.subtitle": "Dostosuj wygląd i układ swojego profilu.",
  "account_edit.profile_tab.title": "Ustawienia wyświetlania profilu",
  "account_edit.save": "Zapisz",
  "account_edit.upload_modal.back": "Wstecz",
  "account_edit.upload_modal.done": "Gotowe",
  "account_edit.upload_modal.next": "Następne",
  "account_edit.upload_modal.step_crop.zoom": "Powiększenie",
  "account_edit.upload_modal.step_upload.button": "Wybierz pliki",
  "account_edit.upload_modal.step_upload.dragging": "Upuść, aby przesłać",
  "account_edit.upload_modal.step_upload.header": "Wybierz obraz",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF lub JPG, maksymalnie {limit} MB.{br}Obraz zostanie przeskalowany do {width}x{height} px.",
  "account_edit.upload_modal.title_add.avatar": "Dodaj zdjęcie profilowe",
  "account_edit.upload_modal.title_add.header": "Dodaj zdjęcie nagłówka",
  "account_edit.upload_modal.title_replace.avatar": "Zmień zdjęcie profilowe",
  "account_edit.upload_modal.title_replace.header": "Zmień zdjęcie nagłówka",
  "account_edit.verified_modal.invisible_link.summary": "Co zrobić, aby link był niewidoczny?",
  "account_edit.verified_modal.title": "Jak dodać zweryfikowany link",
  "account_edit_tags.add_tag": "Dodaj #{tagName}",
  "account_edit_tags.column_title": "Edytuj tagi",
  "account_edit_tags.max_tags_reached": "Osiągnięto maksymalną liczbę wyróżnionych hasztagów.",
  "account_edit_tags.search_placeholder": "Dodaj hashtag...",
  "account_edit_tags.suggestions": "Propozycje:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# post} few {# posty} many {# postów} other {# postów}}",
  "account_list.hidden_notice": "To jest widoczne tylko dla Ciebie. Aby pokazać tę listę innym, przejdź do <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# konto} few {# konta} many {# kont} other {# kont}}",
  "admin.dashboard.daily_retention": "Wskaźnik utrzymania użytkowników według dni od rejestracji",
  "admin.dashboard.monthly_retention": "Wskaźnik utrzymania użytkowników według miesięcy od rejestracji",
  "admin.dashboard.retention.average": "Średnia",
  "admin.dashboard.retention.cohort": "Miesiąc rejestracji",
  "admin.dashboard.retention.cohort_size": "Nowi użytkownicy",
  "admin.impact_report.instance_accounts": "Profile kont, które zostaną usunięte",
  "admin.impact_report.instance_followers": "Obserwujący, których straciliby nasi użytkownicy",
  "admin.impact_report.instance_follows": "Obserwujący, których straciliby ich użytkownicy",
  "admin.impact_report.title": "Podsumowanie zmian",
  "alert.need_reload.message": "Mastodon został zaktualizowany. Niektóre rzeczy mogą nie działać poprawnie, dopóki nie odświeżysz strony.",
  "alert.rate_limited.message": "Spróbuj ponownie po {retry_time, time, medium}.",
  "alert.rate_limited.title": "Ograniczenie liczby zapytań",
  "alert.unexpected.message": "Wystąpił nieoczekiwany błąd.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Tekst alternatywny",
  "alt_text_modal.add_alt_text": "Dodaj tekst alternatywny",
  "alt_text_modal.add_text_from_image": "Dodaj tekst ze zdjęcia",
  "alt_text_modal.cancel": "Anuluj",
  "alt_text_modal.change_thumbnail": "Zmień miniaturę",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Opisz to dla osób niedosłyszących…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Opisz to dla osób niedowidzących…",
  "alt_text_modal.done": "Gotowe",
  "announcement.announcement": "Ogłoszenie",
  "annual_report.announcement.action_build": "Zbuduj mój Wrapstodon",
  "annual_report.announcement.action_dismiss": "Nie, dziękuję",
  "annual_report.announcement.action_view": "Zobacz mój Wrapstodon",
  "annual_report.announcement.description": "Odkryj więcej na temat swojego zaangażowania na Mastodonie w ciągu ostatniego roku.",
  "annual_report.announcement.title": "Wrapstodon {year} przybył",
  "annual_report.nav_item.badge": "Nowe",
  "annual_report.shared_page.donate": "Wesprzyj nas",
  "annual_report.shared_page.footer": "Wygenerowane z {heart} przez zespół Mastodona",
  "annual_report.shared_page.footer_server_info": "Użytkownik {username} używa serwera {domain}, jednej z wielu społeczności wspieranych przez Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "Użytkownik {name} jest na polowaniu na posty do podbicia, wzmacniając innych twórców doskonałym celem.",
  "annual_report.summary.archetype.booster.desc_self": "Jesteś na polowaniu na posty do podbicia, wzmacniając innych twórców doskonałym celem.",
  "annual_report.summary.archetype.booster.name": "Łucznik",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Wiemy, że użytkownik {name} jest tam gdzieś i cieszy się Mastodonem na swój własny, cichy sposób.",
  "annual_report.summary.archetype.lurker.desc_self": "Wiemy, że jesteś tam gdzieś i cieszysz się Mastodonem na swój własny, cichy sposób.",
  "annual_report.summary.archetype.lurker.name": "Stoik",
  "annual_report.summary.archetype.oracle.desc_public": "Użytkownik {name} tworzy więcej nowych postów niż odpowiedzi, utrzymując Mastodona świeżego i przygotowanego na przyszłość.",
  "annual_report.summary.archetype.oracle.desc_self": "Tworzysz więcej nowych postów niż odpowiedzi, utrzymując Mastodona świeżego i przygotowanego na przyszłość.",
  "annual_report.summary.archetype.oracle.name": "Wyrocznia",
  "annual_report.summary.archetype.pollster.desc_public": "Użytkownik {name} tworzy więcej ankiet niż innych rodzajów postów, kultywując ciekawość na Mastodonie.",
  "annual_report.summary.archetype.pollster.desc_self": "Tworzysz więcej ankiet niż innych rodzajów postów, kultywując ciekawość na Mastodonie.",
  "annual_report.summary.archetype.pollster.name": "Zastanawiacz",
  "annual_report.summary.archetype.replier.desc_public": "Użytkownik {name} często odpisuje na posty innych osób, zapylając Mastodona nowymi dyskusjami.",
  "annual_report.summary.archetype.replier.desc_self": "Często odpisujesz na posty innych osób, zapylając Mastodona nowymi dyskusjami.",
  "annual_report.summary.archetype.replier.name": "Motylek",
  "annual_report.summary.archetype.reveal": "Pokaż mój archetyp",
  "annual_report.summary.archetype.reveal_description": "Dziękujemy za bycie częścią Mastodona! Czas na poznanie Twojego archetypu w {year}.",
  "annual_report.summary.archetype.title_public": "Archetyp użytkownika {name}",
  "annual_report.summary.archetype.title_self": "Twój archetyp",
  "annual_report.summary.close": "Zamknij",
  "annual_report.summary.copy_link": "Skopiuj odnośnik",
  "annual_report.summary.followers.new_followers": "{count, plural, one {{counter} obserwujący} few {{counter} obserwujących} many {{counter} obserwujących} other {{counter} obserwujących}}",
  "annual_report.summary.highlighted_post.favourite_count": "Ten post został polubiony {count, plural, one {raz} few {# razy} many {# razy} other {# razy}}.",
  "annual_report.summary.highlighted_post.reply_count": "Ten post ma {count, plural, one {jedną odpowiedź} few {# odpowiedzi} many {# odpowiedzi} other {# odpowiedzi}}.",
  "annual_report.summary.highlighted_post.title": "Najpopularniejszy post",
  "annual_report.summary.most_used_app.most_used_app": "najczęściej używana aplikacja",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "najczęściej używany hashtag",
  "annual_report.summary.new_posts.new_posts": "nowe posty",
  "annual_report.summary.percentile.text": "<topLabel>To plasuje cię w czołówce</topLabel><percentage></percentage><bottomLabel> użytkowników {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Nie powiemy Berniemu.",
  "annual_report.summary.share_elsewhere": "Udostępnij gdzieindziej",
  "annual_report.summary.share_message": "Mam archetyp {archetype}!",
  "annual_report.summary.share_on_mastodon": "Udostępnij na Mastodonie",
  "attachments_list.unprocessed": "(nieprzetworzone)",
  "audio.hide": "Ukryj dźwięk",
  "block_modal.no_collections": "Żadne z Was nie może dodać drugiej osoby do kolekcji. Jeśli takie istnieją, zostaniecie automatycznie usunięci z wzajemnych kolekcji.",
  "block_modal.remote_users_caveat": "Poprosimy serwer {domain} o uszanowanie Twojej decyzji. Nie jest to jednak gwarantowane, ponieważ niektóre serwery mogą obsługiwać blokowania w inny sposób. Publiczne posty mogą być nadal widoczne dla niezalogowanych użytkowników.",
  "block_modal.show_less": "Pokaż mniej",
  "block_modal.show_more": "Pokaż więcej",
  "block_modal.they_cant_mention": "Nie możecie się nawzajem wspominać, obserwować ani cytować.",
  "block_modal.they_cant_see_posts": "Nie zobaczy Twoich treści, a Ty nie zobaczysz jego.",
  "block_modal.they_will_know": "Zobaczy informację o blokadzie.",
  "block_modal.title": "Zablokować?",
  "block_modal.you_wont_see_mentions": "Nie zobaczysz postów od innych, które wspominają o tym użytkowniku.",
  "boost_modal.combo": "Możesz kliknąć {combo}, aby pominąć tę czynność następnym razem",
  "boost_modal.reblog": "Podbić post?",
  "boost_modal.undo_reblog": "Cofnąć podbicie?",
  "bundle_column_error.copy_stacktrace": "Skopiuj raport o błędzie",
  "bundle_column_error.error.body": "Nie udało się wyświetlić tej strony. Może to być spowodowane błędem w naszym kodzie lub niezgodnością przeglądarki.",
  "bundle_column_error.error.title": "O nie!",
  "bundle_column_error.network.body": "Wystąpił błąd podczas próby wczytania tej strony. Może to być spowodowane tymczasowym problemem z połączeniem internetowym lub serwerem.",
  "bundle_column_error.network.title": "Błąd sieci",
  "bundle_column_error.retry": "Spróbuj ponownie",
  "bundle_column_error.return": "Wróć do strony głównej",
  "bundle_column_error.routing.body": "Nie można odnaleźć tej strony. Czy URL w pasku adresu na pewno jest prawidłowy?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zamknij",
  "bundle_modal_error.message": "Coś poszło nie tak podczas wczytywania tego ekranu.",
  "bundle_modal_error.retry": "Spróbuj ponownie",
  "callout.dismiss": "Odrzuć",
  "closed_registrations.other_server_instructions": "Ponieważ Mastodon jest zdecentralizowany, możesz założyć konto na innym serwerze i wciąż mieć możliwość wchodzenia w interakcję z tym serwerem.",
  "closed_registrations_modal.description": "Opcja tworzenia kont na {domain} jest aktualnie niedostępna, ale miej na uwadze to, że nie musisz mieć konta konkretnie na {domain} by używać Mastodona.",
  "closed_registrations_modal.find_another_server": "Znajdź inny serwer",
  "closed_registrations_modal.preamble": "Mastodon jest zdecentralizowany, więc bez względu na to, gdzie się zarejestrujesz, będziesz w stanie obserwować i wchodzić w interakcje z innymi osobami na tym serwerze. Możesz nawet uruchomić własny serwer!",
  "closed_registrations_modal.title": "Rejestracja na Mastodonie",
  "collection.share_modal.share_link_label": "Udostępnij link",
  "collection.share_modal.share_via_post": "Napisz post na Mastodonie",
  "collection.share_modal.share_via_system": "Udostępnij…",
  "collection.share_modal.title": "Udostępnij kolekcję",
  "collection.share_modal.title_new": "Udostępnij swoją nową kolekcję!",
  "collection.share_template_other": "Zobacz tę fajną kolekcję:",
  "collection.share_template_own": "Sprawdź moją nową kolekcję:",
  "collections.account_count": "{count, plural, one {# konto} few {# konta} many {# kont} other {# kont}}",
  "collections.accounts.empty_description": "Dodaj maksymalnie {count} użytkowników",
  "collections.accounts.empty_editor_title": "W tej kolekcji nie ma jeszcze nikogo",
  "collections.accounts.empty_title": "Ta kolekcja jest pusta",
  "collections.add_to_collection": "Dodaj {name} do kolekcji",
  "collections.block_collection_owner": "Zablokuj konto",
  "collections.by_account": "przez {account_handle}",
  "collections.collection_description": "Opis",
  "collections.collection_language": "Język",
  "collections.collection_language_none": "Brak",
  "collections.collection_name": "Nazwa",
  "collections.collection_topic": "Temat",
  "collections.confirm_account_removal": "Czy na pewno chcesz usunąć to konto z tej kolekcji?",
  "collections.content_warning": "Ostrzeżenie o zawartości",
  "collections.continue": "Kontynuuj",
  "collections.copy_link": "Skopiuj link",
  "collections.copy_link_confirmation": "Skopiowano link kolekcji do schowka",
  "collections.create.accounts_title": "Kogo umieścisz w tej kolekcji?",
  "collections.create.basic_details_title": "Podstawowe informacje",
  "collections.create.steps": "Krok {step}/{total}",
  "collections.create_collection": "Utwórz kolekcję",
  "collections.delete_collection": "Usuń kolekcję",
  "collections.description_length_hint": "Limit 100 znaków",
  "collections.detail.loading": "Wczytywanie kolekcji…",
  "collections.detail.revoke_inclusion": "Usuń mnie",
  "collections.detail.sensitive_content": "Wrażliwa zawartość",
  "collections.detail.share": "Udostępnij tę kolekcję",
  "collections.detail.you_are_in_this_collection": "Jesteś wyróżniony w tej kolekcji",
  "collections.edit_details": "Edytuj szczegóły",
  "collections.hidden_accounts_description": "Zablokowano bądź wyciszono {count, plural, one {tego użytkownika} few {tych użytkowników} many {tych użytkowników} other {tych użytkowników}}",
  "collections.hidden_accounts_link": "{count, plural, one {# ukryte konto} few {# ukryte konta} many {# ukrytych kont} other {# ukrytych kont}}",
  "collections.hints.accounts_counter": "{count}/{max} kont",
  "collections.last_updated_at": "Ostatnia aktualizacja: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Kolekcja} few {# Kolekcje} many {# Kolekcji} other {# Kolekcji}}",
  "collections.list.created_by_author": "Utworzone przez {name}",
  "collections.list.created_by_you": "Stworzone przez Ciebie",
  "collections.list.featuring_you": "Zawierające Ciebie",
  "collections.manage_accounts": "Zarządzanie kontami",
  "collections.mark_as_sensitive": "Oznacz jako wrażliwe",
  "collections.mark_as_sensitive_hint": "Ukrywa opis kolekcji i konta za ostrzeżeniem o zawartości. Nazwa kolekcji pozostanie widoczna.",
  "collections.maximum_collection_count_description": "Twój serwer pozwala na tworzenie do {count} kolekcji.",
  "collections.maximum_collection_count_reached": "Utworzono maksymalną liczbę kolekcji",
  "collections.name_length_hint": "Limit 40 znaków",
  "collections.new_collection": "Nowa kolekcja",
  "collections.remove_account": "Usuń",
  "collections.report_collection": "Zgłoś tę kolekcję",
  "collections.revoke_collection_inclusion": "Usuń się z tej kolekcji",
  "collections.revoke_inclusion.confirmation": "Zostałeś(aś) usunięty(a) z \"{collection}\"",
  "collections.revoke_inclusion.error": "Wystąpił błąd, proszę spróbować ponownie później.",
  "collections.search_accounts_label": "Wyszukaj konto do dodania",
  "collections.search_accounts_max_reached": "Przekroczono maksymalną liczbę dodanych użytkowników",
  "collections.share_short": "Udostępnij",
  "collections.sort_alphabetical": "Alfabetycznie",
  "collections.sort_by": "Sortuj według:",
  "collections.sort_date_added": "Data dodania",
  "collections.sort_last_active": "Ostatnia aktywność",
  "collections.sort_most_followers": "Najwięcej obserwujących",
  "collections.suggestions.can_not_add": "Nie można dodać",
  "collections.suggestions.can_not_add_desc": "Te konta mogły zrezygnować z funkcji odkrywania albo znajdują się na serwerze, który nie obsługuje kolekcji.",
  "collections.suggestions.must_follow": "Musisz najpierw obserwować",
  "collections.topic_hint": "Dodaj hasztag, który pomoże innym zrozumieć główny temat tej kolekcji.",
  "collections.topic_special_chars_hint": "Znaki specjalne zostaną usunięte podczas zapisywania",
  "collections.view_collection": "Pokaż kolekcję",
  "collections.visibility_public": "Publiczna",
  "collections.visibility_public_hint": "Widoczna w wynikach wyszukiwania i innych miejscach, gdzie pojawiają się rekomendacje.",
  "collections.visibility_title": "Widoczność",
  "collections.visibility_unlisted": "Niewidoczna",
  "collections.visibility_unlisted_hint": "Widoczna dla każdego, kto ma link. Ukryta w wynikach wyszukiwania i rekomendacjach.",
  "column.about": "O serwerze",
  "column.blocks": "Zablokowani",
  "column.bookmarks": "Zakładki",
  "column.community": "Lokalna oś czasu",
  "column.create_list": "Utwórz listę",
  "column.direct": "Wzmianki bezpośrednie",
  "column.directory": "Przeglądaj profile",
  "column.domain_blocks": "Zablokowane domeny",
  "column.edit_list": "Edytuj listę",
  "column.favourites": "Ulubione",
  "column.firehose": "Aktualności",
  "column.firehose_local": "Kanał na żywo dla tego serwera",
  "column.firehose_singular": "Na żywo",
  "column.follow_requests": "Prośby o obserwację",
  "column.home": "Strona główna",
  "column.list_members": "Zarządzaj osobami na liście",
  "column.lists": "Listy",
  "column.mutes": "Wyciszeni",
  "column.notifications": "Powiadomienia",
  "column.other_collections": "Kolekcje od użytkownika {name}",
  "column.pins": "Przypięte wpisy",
  "column.public": "Globalna oś czasu",
  "column.your_collections": "Twoje kolekcje",
  "column_back_button.label": "Wróć",
  "column_header.hide_settings": "Ukryj ustawienia",
  "column_header.moveLeft_settings": "Przesuń kolumnę w lewo",
  "column_header.moveRight_settings": "Przesuń kolumnę w prawo",
  "column_header.pin": "Przypnij",
  "column_header.show_settings": "Pokaż ustawienia",
  "column_header.unpin": "Odepnij",
  "column_search.cancel": "Anuluj",
  "combobox.close_results": "Zamknij wyniki",
  "combobox.loading": "Wczytywanie",
  "combobox.no_results_found": "Brak wyników dla tego wyszukiwania",
  "combobox.open_results": "Otwórz wyniki",
  "community.column_settings.local_only": "Tylko lokalne",
  "community.column_settings.media_only": "Tylko multimedia",
  "community.column_settings.remote_only": "Tylko zdalne",
  "compose.error.blank_post": "Post nie może być pusty.",
  "compose.language.change": "Zmień język",
  "compose.language.search": "Wyszukaj języki...",
  "compose.published.body": "Post został opublikowany.",
  "compose.published.open": "Otwórz",
  "compose.saved.body": "Post został zapisany.",
  "compose_form.direct_message_warning_learn_more": "Dowiedz się więcej",
  "compose_form.encryption_warning": "Posty na Mastodonie nie są szyfrowane end-to-end. Nie udostępniaj żadnych poufnych informacji za pośrednictwem Mastodona.",
  "compose_form.hashtag_warning": "Ten post nie będzie wyświetlany pod żadnym tagiem, bo nie jest publiczny. Tylko publiczne posty mogą być wyszukiwane po tagach.",
  "compose_form.lock_disclaimer": "Twoje konto nie jest {locked}. Wszyscy mogą Cię zaobserwować, aby zobaczyć Twoje posty tylko dla obserwujących.",
  "compose_form.lock_disclaimer.lock": "zablokowane",
  "compose_form.placeholder": "Co ci chodzi po głowie?",
  "compose_form.poll.duration": "Czas trwania ankiety",
  "compose_form.poll.multiple": "Możliwość wielokrotnego wyboru",
  "compose_form.poll.option_placeholder": "Opcja {number}",
  "compose_form.poll.single": "Maksymalnie jedna odpowiedź",
  "compose_form.poll.switch_to_multiple": "Pozwól na zaznaczenie kilku odpowiedzi",
  "compose_form.poll.switch_to_single": "Pozwól na zaznaczenie tylko jednej odpowiedzi",
  "compose_form.poll.type": "Styl",
  "compose_form.publish": "Opublikuj",
  "compose_form.reply": "Skomentuj",
  "compose_form.save_changes": "Aktualizuj",
  "compose_form.spoiler.marked": "Usuń ostrzeżenie o treści",
  "compose_form.spoiler.unmarked": "Dodaj ostrzeżenie o treści",
  "compose_form.spoiler_placeholder": "Ostrzeżenie o treści (opcjonalne)",
  "confirmation_modal.cancel": "Anuluj",
  "confirmations.block.confirm": "Zablokuj",
  "confirmations.delete.confirm": "Usuń",
  "confirmations.delete.message": "Czy na pewno chcesz usunąć ten post?",
  "confirmations.delete.title": "Usunąć post?",
  "confirmations.delete_collection.confirm": "Usuń",
  "confirmations.delete_collection.message": "Tej czynności nie da się cofnąć.",
  "confirmations.delete_collection.title": "Usunąć „{name}\"?",
  "confirmations.delete_list.confirm": "Usuń",
  "confirmations.delete_list.message": "Czy na pewno chcesz trwale usunąć tę listę?",
  "confirmations.delete_list.title": "Usunąć listę?",
  "confirmations.discard_draft.confirm": "Odrzuć i kontynuuj",
  "confirmations.discard_draft.edit.cancel": "Wznów edytowanie",
  "confirmations.discard_draft.edit.message": "Kontynuowanie spowoduje utratę wszelkich zmian wprowadzonych w aktualnie edytowanym poście.",
  "confirmations.discard_draft.edit.title": "Czy chcesz odrzucić zmiany w swoim poście?",
  "confirmations.discard_draft.post.cancel": "Wznów szkic",
  "confirmations.discard_draft.post.message": "Kontynuowanie spowoduje utracenie aktualnie pisanego posta.",
  "confirmations.discard_draft.post.title": "Odrzucić szkic postu?",
  "confirmations.discard_edit_media.confirm": "Odrzuć",
  "confirmations.discard_edit_media.message": "Masz niezapisane zmiany w opisie lub podglądzie multimediów. Czy chcesz je mimo to odrzucić?",
  "confirmations.follow_to_list.confirm": "Obserwuj i dodaj do listy",
  "confirmations.follow_to_list.message": "Musisz obserwować {name}, aby dodać do listy.",
  "confirmations.follow_to_list.title": "Zaobserwować?",
  "confirmations.hide_featured_tab.confirm": "Ukryj zakładkę",
  "confirmations.hide_featured_tab.title": "Ukryć zakładkę \"Wyróżnione\"?",
  "confirmations.logout.confirm": "Wyloguj",
  "confirmations.logout.message": "Czy na pewno chcesz się wylogować?",
  "confirmations.logout.title": "Wylogować?",
  "confirmations.missing_alt_text.confirm": "Dodaj opis pomocniczy",
  "confirmations.missing_alt_text.message": "Twój post zawiera multimedia bez tekstu alternatywnego. Dodanie opisów pomaga zwiększyć dostępność tych treści dla większej liczby osób.",
  "confirmations.missing_alt_text.secondary": "Opublikuj mimo wszystko",
  "confirmations.missing_alt_text.title": "Dodać tekst pomocniczy?",
  "confirmations.mute.confirm": "Wycisz",
  "confirmations.private_quote_notify.cancel": "Wróć do edycji",
  "confirmations.private_quote_notify.confirm": "Opublikuj post",
  "confirmations.private_quote_notify.do_not_show_again": "Nie pokazuj tej wiadomości ponownie",
  "confirmations.private_quote_notify.message": "Osoba, którą cytujesz, a inne wzmianki zostaną powiadomione i będą mogły zobaczyć Twój post, nawet jeśli nie obserwują Ciebie.",
  "confirmations.private_quote_notify.title": "Udostępnić obserwującym i wspomnianym użytkownikom?",
  "confirmations.quiet_post_quote_info.dismiss": "Nie przypominaj mi ponownie",
  "confirmations.quiet_post_quote_info.got_it": "Rozumiem",
  "confirmations.quiet_post_quote_info.message": "Kiedy cytujesz niewidoczny post publiczny, Twój post zostanie ukryty z popularnych osi czasu.",
  "confirmations.quiet_post_quote_info.title": "Cytowanie niewidocznych postów publicznych",
  "confirmations.redraft.confirm": "Usuń i popraw",
  "confirmations.redraft.message": "Czy na pewno chcesz usunąć i przeredagować ten post? Polubienia i podbicia zostaną utracone, a komentarze do pierwotnego posta zostaną osierocone.",
  "confirmations.redraft.title": "Usunąć i przeredagować post?",
  "confirmations.remove_from_followers.confirm": "Usuń z obserwujących",
  "confirmations.remove_from_followers.message": "{name} przestanie cię obserwować. Czy na pewno chcesz kontynuować?",
  "confirmations.remove_from_followers.title": "Usunąć z obserwujących?",
  "confirmations.revoke_collection_inclusion.confirm": "Usuń mnie",
  "confirmations.revoke_quote.confirm": "Usuń post",
  "confirmations.revoke_quote.message": "Tej czynności nie można cofnąć.",
  "confirmations.revoke_quote.title": "Usunąć post?",
  "confirmations.unblock.confirm": "Odblokuj",
  "confirmations.unblock.title": "Odblokować {name}?",
  "confirmations.unfollow.confirm": "Nie obserwuj",
  "confirmations.unfollow.title": "Przestać obserwować {name}?",
  "confirmations.withdraw_request.confirm": "Wycofaj prośbę",
  "confirmations.withdraw_request.title": "Wycofać prośbę o zgodę na obserwowanie {name}?",
  "content_warning.hide": "Ukryj post",
  "content_warning.show": "Pokaż mimo to",
  "content_warning.show_more": "Pokaż więcej",
  "content_warning.show_short": "Pokaż",
  "conversation.delete": "Usuń rozmowę",
  "conversation.mark_as_read": "Oznacz jako przeczytane",
  "conversation.open": "Zobacz rozmowę",
  "conversation.with": "Z {names}",
  "copy_icon_button.copied": "Skopiowano do schowka",
  "copy_icon_button.copy_this_text": "Skopiuj linki do schowka",
  "copypaste.copied": "Skopiowano",
  "copypaste.copy_to_clipboard": "Skopiuj do schowka",
  "custom_homepage.contact": "Kontakt:",
  "custom_homepage.these_are_the_latest_posts": "To są najnowsze 40 postów z kont na tym serwerze.",
  "directory.federated": "Ze znanego fediwersum",
  "directory.local": "Tylko z {domain}",
  "directory.new_arrivals": "Nowo przybyli",
  "directory.recently_active": "Ostatnio aktywni",
  "disabled_account_banner.account_settings": "Ustawienia konta",
  "disabled_account_banner.text": "Twoje konto {disabledAccount} jest obecnie wyłączone.",
  "dismissable_banner.community_timeline": "To są najnowsze publiczne posty osób, których konta są na serwerze {domain}.",
  "dismissable_banner.dismiss": "Odrzuć",
  "dismissable_banner.public_timeline": "To są najnowsze publiczne posty w fediwersum od osób obserwowanych przez użytkowników serwera {domain}.",
  "domain_block_modal.block": "Blokuj serwer",
  "domain_block_modal.block_account_instead": "Zamiast tego zablokuj @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Osoby z tego serwera mogą wchodzić w interakcje z Twoimi starymi postami.",
  "domain_block_modal.they_cant_follow": "Nikt z tego serwera nie może cię obserwować.",
  "domain_block_modal.they_wont_know": "Nie będą wiedzieć, że zostali zablokowani.",
  "domain_block_modal.title": "Zablokować domenę?",
  "domain_block_modal.you_will_lose_num_followers": "Utracisz {followersCount, plural, one {jednego obserwującego} other {{followersCountDisplay} obserwujących}} i {followingCount, plural, one {jedną osobę którą obserwujesz} few {{followingCountDisplay} osoby które obserwujesz} other {{followingCountDisplay} osób które obserwujesz}}.",
  "domain_block_modal.you_will_lose_relationships": "Utracisz wszystkich obserwujących i obserwowanych z tego serwera.",
  "domain_block_modal.you_wont_see_posts": "Nie zobaczysz postów ani powiadomień od użytkowników z tego serwera.",
  "dropdown.empty": "Wybierz opcję",
  "email_subscriptions.email": "E-mail",
  "email_subscriptions.form.bottom": "Otrzymuj posty na swoją skrzynkę bez zakładania konta na Mastodonie. Możesz zrezygnować w dowolnym momencie. Więcej informacji znajdziesz w <a>Polityce prywatności</a>.",
  "email_subscriptions.submitted.title": "Jeszcze jeden krok",
  "email_subscriptions.validation.email.invalid": "Nieprawidłowy adres e-mail",
  "embed.instructions": "Umieść ten post na swojej stronie poprzez skopiowanie poniższego kodu.",
  "embed.preview": "Tak to będzie wyglądać:",
  "emoji_button.activity": "Aktywność",
  "emoji_button.clear": "Wyczyść",
  "emoji_button.custom": "Niestandardowe",
  "emoji_button.flags": "Flagi",
  "emoji_button.food": "Żywność i napoje",
  "emoji_button.label": "Wstaw emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Nie znaleziono pasujących emoji",
  "emoji_button.objects": "Obiekty",
  "emoji_button.people": "Ludzie",
  "emoji_button.recent": "Najczęściej używane",
  "emoji_button.search": "Wyszukaj...",
  "emoji_button.search_results": "Wyniki wyszukiwania",
  "emoji_button.symbols": "Symbole",
  "emoji_button.travel": "Podróże i miejsca",
  "empty_column.account_featured_self.no_collections_button": "Stwórz kolekcję",
  "empty_column.account_featured_self.showcase_accounts": "Pokaż swoje ulubione konta",
  "empty_column.account_featured_self.showcase_accounts_desc": "Kolekcje to wyselekcjonowane listy kont, które pomagają innym odkrywać więcej zakątków Fediwersum.",
  "empty_column.account_hides_collections": "Ta osoba postanowiła nie udostępniać tych informacji",
  "empty_column.account_suspended": "Konto zawieszone",
  "empty_column.account_timeline": "Brak postów tutaj!",
  "empty_column.account_unavailable": "Profil niedostępny",
  "empty_column.blocks": "Nie zablokowano jeszcze żadnych użytkowników.",
  "empty_column.bookmarked_statuses": "Nie dodano jeszcze żadnego postu do zakładek. Kiedy to zrobisz, pojawi się on tutaj.",
  "empty_column.collections.featured_in": "Nie zostałeś jeszcze dodany do żadnej kolekcji.",
  "empty_column.collections.featured_in_undiscoverable": "Aby inni mogli dodawać Cię do kolekcji, musisz zezwolić na wyróżnianie w miejscach do odkrywania treści w <link>Preferencje > Prywatność i zasięg</link>",
  "empty_column.community": "Lokalna oś czasu jest pusta. Opublikuj coś, by ruszyć z kopyta!",
  "empty_column.direct": "Nie ma tu jeszcze żadnych wzmianek bezpośrednich. Gdy je wyślesz lub otrzymasz, pojawią się tutaj.",
  "empty_column.disabled_feed": "Ten kanał został wyłączony przez administratorów serwera.",
  "empty_column.domain_blocks": "Brak zablokowanych domen.",
  "empty_column.explore_statuses": "Nic nie cieszy się teraz popularnością. Sprawdź później!",
  "empty_column.favourited_statuses": "Nie polubiono jeszcze żadnego postu. Kiedy to zrobisz, pojawi się on tutaj.",
  "empty_column.favourites": "Nikt jeszcze nie polubił tego postu. Kiedy ktoś to zrobi, pojawi się tutaj.",
  "empty_column.follow_requests": "Nie masz jeszcze żadnych próśb o obserwowanie. Gdy je otrzymasz, pojawią się tutaj.",
  "empty_column.followed_tags": "Nie obserwujesz jeszcze żadnych hashtagów. Gdy to zrobisz, pojawią się tutaj.",
  "empty_column.hashtag": "Nie ma jeszcze postów oznaczonych tym tagiem.",
  "empty_column.home": "Twoja główna oś czasu jest pusta! Zaobserwuj więcej osób, aby coś zobaczyć.",
  "empty_column.list": "Nie ma nic na tej liście. Kiedy członkowie listy dodadzą nowe posty, pojawia się one tutaj.",
  "empty_column.mutes": "Nie wyciszono jeszcze żadnego użytkownika.",
  "empty_column.notification_requests": "Wszystko przeczytane! Gdy otrzymasz nowe powiadomienia, pojawią się tutaj zgodnie z twoimi ustawieniami.",
  "empty_column.notifications": "Nie masz jeszcze żadnych powiadomień. Gdy inne osoby wejdą z tobą w interakcję, zobaczysz to tutaj.",
  "empty_column.public": "Nic tu nie ma! Opublikuj coś lub obserwuj osoby z innych serwerów, aby coś zobaczyć",
  "empty_state.no_results": "Brak wyników",
  "error.unexpected_crash.explanation": "Z powodu błędu w naszym kodzie lub niezgodności przeglądarki nie udało się poprawnie wyświetlić tej strony.",
  "error.unexpected_crash.explanation_addons": "Nie udało się poprawnie wyświetlić tej strony. Ten błąd jest spowodowany zapewne przez wtyczkę do przeglądarki lub narzędzia do automatycznego tłumaczenia.",
  "error.unexpected_crash.next_steps": "Spróbuj odświeżyć stronę. Jeśli to nie pomoże, nadal możesz korzystać z Mastodon za pośrednictwem innej przeglądarki lub aplikacji.",
  "error.unexpected_crash.next_steps_addons": "Spróbuj je wyłączyć i odświeżyć stronę. Jeśli to nie pomoże, nadal możesz korzystać z Mastodon za pośrednictwem innej przeglądarki lub aplikacji.",
  "errors.unexpected_crash.copy_stacktrace": "Skopiuj stacktrace do schowka",
  "errors.unexpected_crash.report_issue": "Zgłoś problem",
  "explore.suggested_follows": "Ludzie",
  "explore.title": "Na czasie",
  "explore.trending_links": "Aktualności",
  "explore.trending_statuses": "Posty",
  "explore.trending_tags": "Hasztagi",
  "featured_carousel.header": "{count, plural, one {Przypięty post} few {Przypięte posty} many {Przypięte posty} other {Przypięte posty}}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions.add": "Dodaj",
  "featured_tags.suggestions.dismiss": "Nie, dziękuję",
  "filter_modal.added.context_mismatch_explanation": "To filtrowanie nie dotyczy kategorii, w której pojawił się ten post. Jeśli chcesz, aby ten post był filtrowany również w tym kontekście, musisz edytować ustawienia filtrowania.",
  "filter_modal.added.context_mismatch_title": "Niewłaściwy kontekst!",
  "filter_modal.added.expired_explanation": "Ta kategoria filtrowania wygasła, aby ją zastosować, należy zmienić datę wygaśnięcia.",
  "filter_modal.added.expired_title": "Filtr wygasł!",
  "filter_modal.added.review_and_configure": "Aby przejrzeć i skonfigurować tę kategorię filtrowania, przejdź do {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Ustawienia filtrowania",
  "filter_modal.added.settings_link": "strona ustawień",
  "filter_modal.added.short_explanation": "Ten post został dodany do następującej kategorii filtrowania: {title}.",
  "filter_modal.added.title": "Filtrowanie zostało dodane!",
  "filter_modal.select_filter.context_mismatch": "nie ma zastosowania w tym kontekście",
  "filter_modal.select_filter.expired": "wygasły",
  "filter_modal.select_filter.prompt_new": "Nowa kategoria: {name}",
  "filter_modal.select_filter.search": "Szukaj lub utwórz",
  "filter_modal.select_filter.subtitle": "Użyj istniejącej kategorii lub utwórz nową",
  "filter_modal.select_filter.title": "Odfiltruj ten wpis",
  "filter_modal.title.status": "Odfiltruj wpis",
  "filter_warning.matches_filter": "Odfiltrowane przez \"<span>{title}</span>\"",
  "filtered_notifications_banner.pending_requests": "Od {count, plural, =0 {żadnej osoby którą możesz znać} one {# osoby którą możesz znać} other {# osób które możesz znać}}",
  "filtered_notifications_banner.title": "Odfiltrowane powiadomienia",
  "firehose.all": "Wszystko",
  "firehose.local": "Ten serwer",
  "firehose.remote": "Inne serwery",
  "follow_request.authorize": "Przyjmij",
  "follow_request.reject": "Odrzuć",
  "follow_requests.unlocked_explanation": "Mimo że twoje konto nie jest zablokowane, administratorzy {domain} uznali, że możesz chcieć samodzielnie sprawdzić prośby o obserwowanie od tych osób.",
  "follow_suggestions.curated_suggestion": "Wybrane przez redakcję",
  "follow_suggestions.dismiss": "Nie pokazuj ponownie",
  "follow_suggestions.featured_longer": "Wybrane przez redakcję {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popularne wśród obserwowanych",
  "follow_suggestions.hints.featured": "Ten profil został wybrany przez redakcję {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ten profil jest popularny wśród obserwowanych.",
  "follow_suggestions.hints.most_followed": "Ten profil jest jednym z najczęściej obserwowanych na {domain}.",
  "follow_suggestions.hints.most_interactions": "Ten profil cieszy się ostatnio dużym zainteresowaniem na {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ten profil jest podobny do ostatnio przez ciebie zaobserwowanych.",
  "follow_suggestions.personalized_suggestion": "Spersonalizowana rekomendacja",
  "follow_suggestions.popular_suggestion": "Popularna rekomendacja",
  "follow_suggestions.popular_suggestion_longer": "Popularne na {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Podobne do ostatnio zaobserwowanych",
  "follow_suggestions.view_all": "Pokaż wszystkie",
  "follow_suggestions.who_to_follow": "Kogo warto obserwować",
  "followed_tags": "Obserwowane hasztagi",
  "followers.title": "Obserwujący {name}",
  "following.hide_other_following": "Ten użytkownik ukrył pozostałe obserwowane konta",
  "following.title": "Obserwowani przez {name}",
  "footer.about": "O serwerze",
  "footer.about_mastodon": "O Mastodonie",
  "footer.about_server": "O {domain}",
  "footer.about_this_server": "O nas",
  "footer.directory": "Katalog profili",
  "footer.get_app": "Pobierz aplikację",
  "footer.keyboard_shortcuts": "Skróty klawiszowe",
  "footer.privacy_policy": "Polityka prywatności",
  "footer.source_code": "Zobacz kod źródłowy",
  "footer.status": "Status",
  "footer.terms_of_service": "Regulamin",
  "form_field.optional": "(opcjonalnie)",
  "getting_started.heading": "Pierwsze kroki",
  "hashtag.admin_moderation": "Otwórz interfejs moderacji #{name}",
  "hashtag.browse": "Przeglądaj posty z #{hashtag}",
  "hashtag.browse_from_account": "Przeglądaj posty od @{name} z #{hashtag}",
  "hashtag.column_header.tag_mode.all": "i {additional}",
  "hashtag.column_header.tag_mode.any": "lub {additional}",
  "hashtag.column_header.tag_mode.none": "bez {additional}",
  "hashtag.column_settings.select.no_options_message": "Nie znaleziono żadnych rekomendacji",
  "hashtag.column_settings.select.placeholder": "Wprowadź hasztagi…",
  "hashtag.column_settings.tag_mode.all": "Wszystkie",
  "hashtag.column_settings.tag_mode.any": "Dowolne",
  "hashtag.column_settings.tag_mode.none": "Żadne",
  "hashtag.column_settings.tag_toggle": "Uwzględnij dodatkowe tagi w tej kolumnie",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} osoba} few {{counter} osoby} many {{counter} osób} other {{counter} osób}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} wpis} few {{counter} wpisy} many {{counter} wpisów} other {{counter} wpisów}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} wpis} few {{counter} wpisy} many {{counter} wpisów} other {{counter} wpisów}} dzisiaj",
  "hashtag.feature": "Wyróżnij w profilu",
  "hashtag.follow": "Obserwuj hasztag",
  "hashtag.mute": "Wycisz #{hashtag}",
  "hashtag.unfeature": "Nie wyróżniaj w profilu",
  "hashtag.unfollow": "Przestań obserwować hashtag",
  "hashtags.and_other": "…i {count, plural, other {jeszcze #}}",
  "hints.profiles.followers_may_be_missing": "Niektórzy obserwujący ten profil mogą być niewidoczni.",
  "hints.profiles.follows_may_be_missing": "Niektórzy obserwowani mogą być niewidoczni.",
  "hints.profiles.posts_may_be_missing": "Niektóre wpisy mogą być niewidoczne.",
  "hints.profiles.see_more_followers": "Zobacz więcej obserwujących na {domain}",
  "hints.profiles.see_more_follows": "Zobacz więcej obserwowanych na {domain}",
  "hints.profiles.see_more_posts": "Zobacz więcej wpisów na {domain}",
  "home.column_settings.show_quotes": "Pokaż cytaty",
  "home.column_settings.show_reblogs": "Pokazuj podbicia",
  "home.column_settings.show_replies": "Pokazuj odpowiedzi",
  "home.hide_announcements": "Ukryj ogłoszenia",
  "home.pending_critical_update.body": "Prosimy o jak najszybszą aktualizację serwera Mastodon!",
  "home.pending_critical_update.link": "Zobacz aktualizacje",
  "home.pending_critical_update.title": "Dostępna krytyczna aktualizacja bezpieczeństwa!",
  "home.show_announcements": "Pokaż ogłoszenia",
  "ignore_notifications_modal.bots_title": "Ignorować powiadomienia od botów?",
  "ignore_notifications_modal.disclaimer": "Mastodon nie informuje nikogo o zignorowaniu powiadomienia. Ignorowanie powiadomień nie zapobiegnie wysyłaniu samych wiadomości.",
  "ignore_notifications_modal.filter_instead": "Zamiast tego odfiltruj",
  "ignore_notifications_modal.filter_to_act_users": "Przyjmowanie, odrzucanie i zgłaszanie innych będzie nadal możliwe",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrowanie pomaga uniknąć ewentualnych pomyłek",
  "ignore_notifications_modal.filter_to_review_separately": "Możesz sprawdzić każde odfiltrowane powiadomienie",
  "ignore_notifications_modal.ignore": "Ignoruj powiadomienia",
  "ignore_notifications_modal.limited_accounts_title": "Ignorować powiadomienia z moderowanych kont?",
  "ignore_notifications_modal.new_accounts_title": "Ignorować powiadomienia z nowych kont?",
  "ignore_notifications_modal.not_followers_title": "Ignorować powiadomienia od osób, które Cię nie obserwują?",
  "ignore_notifications_modal.not_following_title": "Ignorować powiadomienia od osób, których nie obserwujesz?",
  "ignore_notifications_modal.private_mentions_title": "Ignorować powiadomienia od niechcianych wzmianek bezpośrednich?",
  "info_button.label": "Pomoc",
  "info_button.what_is_alt_text": "<h1>Czym jest tekst alternatywny?</h1><p>Tekst alternatywny zawiera opisy zdjęć dla osób niedowidzących, korzystających z połączeń o niskiej przepustowości lub szukających dodatkowego kontekstu.</p>\n<p>Możesz poprawić dostępność i czytelność dla wszystkich, pisząc jasny, zwięzły i precyzyjny tekst alternatywny.</p>\n<ul>\n<li>Podkreśl ważne elementy</li>\n<li>Streść tekst widoczny na zdjęciach</li>\n<li>Używaj poprawnej struktury zdań</li>\n<li>Unikaj zbędnych informacji</li>\n<li>Skoncentruj się na kluczowych informacjach zawartych w złożonych wizualizacjach (takich jak diagramy lub mapy)</li>\n</ul>",
  "interaction_modal.action": "Aby wejść w interakcję z wpisem od {name}, musisz zalogować się na swoje konto na dowolnym serwerze Mastodon, na którym masz już konto.",
  "interaction_modal.action_follow": "Aby obserwować {name}, musisz zalogować się na swoje konto na dowolnym serwerze Mastodona.",
  "interaction_modal.go": "Dalej",
  "interaction_modal.no_account_yet": "Nie masz jeszcze konta?",
  "interaction_modal.on_another_server": "Na innym serwerze",
  "interaction_modal.on_this_server": "Na tym serwerze",
  "interaction_modal.title": "Zaloguj się, aby kontynuować",
  "interaction_modal.username_prompt": "Np. {example}",
  "intervals.full.days": "{number, plural, one {# dzień} few {# dni} many {# dni} other {# dni}}",
  "intervals.full.hours": "{number, plural, one {# godzina} few {# godziny} many {# godzin} other {# godzin}}",
  "intervals.full.minutes": "{number, plural, one {# minuta} few {# minuty} many {# minut} other {# minut}}",
  "keyboard_shortcuts.back": "Wstecz",
  "keyboard_shortcuts.blocked": "Otwórz listę zablokowanych",
  "keyboard_shortcuts.boost": "Podbij wpis",
  "keyboard_shortcuts.column": "Aktywuj kolumnę",
  "keyboard_shortcuts.compose": "Aktywuj pole tekstowe",
  "keyboard_shortcuts.description": "Opis",
  "keyboard_shortcuts.down": "Przesuń w dół na liście",
  "keyboard_shortcuts.enter": "Otwórz wpis",
  "keyboard_shortcuts.favourite": "Polub wpis",
  "keyboard_shortcuts.favourites": "Otwórz listę polubionych wpisów",
  "keyboard_shortcuts.federated": "Otwórz globalną oś czasu",
  "keyboard_shortcuts.heading": "Skróty klawiszowe",
  "keyboard_shortcuts.home": "Otwórz stronę główną",
  "keyboard_shortcuts.hotkey": "Skrót klawiszowy",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "Page Up",
  "keyboard_shortcuts.legend": "Wyświetl skróty klawiszowe",
  "keyboard_shortcuts.load_more": "Aktywuj przycisk \"Załaduj więcej\"",
  "keyboard_shortcuts.local": "Otwórz lokalną oś czasu",
  "keyboard_shortcuts.mention": "Dodaj wzmiankę",
  "keyboard_shortcuts.muted": "Otwórz listę wyciszonych",
  "keyboard_shortcuts.my_profile": "Otwórz swój profil",
  "keyboard_shortcuts.notifications": "Otwórz kolumnę powiadomień",
  "keyboard_shortcuts.open_media": "Otwórz multimedia",
  "keyboard_shortcuts.pinned": "Otwórz listę przypiętych wpisów",
  "keyboard_shortcuts.profile": "Otwórz profil",
  "keyboard_shortcuts.quote": "Cytuj post",
  "keyboard_shortcuts.reply": "Skomentuj",
  "keyboard_shortcuts.requests": "Otwórz listę próśb o obserwowanie",
  "keyboard_shortcuts.search": "Aktywuj pole wyszukiwania",
  "keyboard_shortcuts.spoilers": "Pokaż lub ukryj ostrzeżenia",
  "keyboard_shortcuts.start": "Otwórz kolumnę \"Pierwsze kroki\"",
  "keyboard_shortcuts.toggle_hidden": "Pokaż lub ukryj tekst z ostrzeżeniem",
  "keyboard_shortcuts.toggle_sensitivity": "Pokaż lub ukryj multimedia",
  "keyboard_shortcuts.toot": "Stwórz nowy wpis",
  "keyboard_shortcuts.top": "Przenieś na górę listy",
  "keyboard_shortcuts.translate": "Przetłumacz wpis",
  "keyboard_shortcuts.unfocus": "Opuść pole tekstowe",
  "keyboard_shortcuts.up": "Przesuń w górę na liście",
  "learn_more_link.got_it": "Rozumiem",
  "learn_more_link.learn_more": "Dowiedz się więcej",
  "lightbox.close": "Zamknij",
  "lightbox.next": "Następne",
  "lightbox.previous": "Poprzednie",
  "lightbox.zoom_in": "Powiększ do rzeczywistego rozmiaru",
  "lightbox.zoom_out": "Powiększ, aby dopasować",
  "limited_account_hint.action": "Pokaż profil mimo to",
  "limited_account_hint.title": "Ten profil lub serwer został ukryty przez moderatorów {domain}.",
  "link_preview.author": "{name}",
  "link_preview.more_from_author": "Więcej od {name}",
  "link_preview.shares": "{count, plural, one {{counter} wpis} few {{counter} wpisy} many {{counter} wpisów} other {{counter} wpisów}}",
  "lists.add_member": "Dodaj",
  "lists.add_to_list": "Dodaj do listy",
  "lists.add_to_lists": "Dodaj {name} do list",
  "lists.create": "Utwórz",
  "lists.create_a_list_to_organize": "Utwórz nową listę, aby uporządkować swoją oś czasu",
  "lists.create_list": "Utwórz listę",
  "lists.delete": "Usuń listę",
  "lists.done": "Gotowe",
  "lists.edit": "Edytuj listę",
  "lists.exclusive": "Nie pokazuj w mojej osi czasu",
  "lists.exclusive_hint": "Wpisy osób znajdujących się na tej liście nie będą wyświetlane na Twojej osi czasu, aby uniknąć duplikowania tych samych wpisów.",
  "lists.find_users_to_add": "Znajdź kogoś, aby dodać",
  "lists.list_members_count": "{count, plural, one {# osoba} few {# osoby} many {# osób} other {# osób}}",
  "lists.list_name": "Nazwa listy",
  "lists.new_list_name": "Nazwa nowej listy",
  "lists.no_lists_yet": "Brak list.",
  "lists.no_members_yet": "Pusto.",
  "lists.no_results_found": "Nic nie znaleziono.",
  "lists.remove_member": "Usuń",
  "lists.replies_policy.followed": "Każdy obserwowany",
  "lists.replies_policy.list": "Osoby na liście",
  "lists.replies_policy.none": "Nikt",
  "lists.save": "Zapisz",
  "lists.search": "Szukaj",
  "lists.show_replies_to": "Uwzględnij komentarze członków listy do",
  "load_pending": "{count, plural, one {# nowa} few {# nowe} many {# nowych} other {# nowych}}",
  "loading_indicator.label": "Wczytywanie…",
  "media_gallery.hide": "Ukryj",
  "moved_to_account_banner.text": "Twoje konto {disabledAccount} jest obecnie wyłączone, ponieważ zostało przeniesione na {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Nie pokazuj w powiadomieniach",
  "mute_modal.hide_options": "Ukryj opcje",
  "mute_modal.indefinite": "Dopóki nie zmienię zdania",
  "mute_modal.show_options": "Pokaż opcje",
  "mute_modal.they_can_mention_and_follow": "Może cię wzmiankować i obserwować, ale ty tego nie zobaczysz.",
  "mute_modal.they_wont_know": "Informacja o wyciszeniu nie będzie widoczna dla tej osoby.",
  "mute_modal.title": "Wyciszyć?",
  "mute_modal.you_wont_see_mentions": "Nie zobaczysz wpisów wzmiankujących tę osobę.",
  "mute_modal.you_wont_see_posts": "Nie zobaczysz wpisów tej osoby, ale ona może widzieć twoje.",
  "navigation_bar.about": "O serwerze",
  "navigation_bar.account_settings": "Hasło i zabezpieczenia",
  "navigation_bar.administration": "Administracja",
  "navigation_bar.advanced_interface": "Otwórz w widoku zaawansowanym",
  "navigation_bar.automated_deletion": "Automatyczne usuwanie postów",
  "navigation_bar.blocks": "Zablokowani",
  "navigation_bar.bookmarks": "Zakładki",
  "navigation_bar.collections": "Kolekcje",
  "navigation_bar.direct": "Wzmianki bezpośrednie",
  "navigation_bar.domain_blocks": "Zablokowane domeny",
  "navigation_bar.favourites": "Polubione",
  "navigation_bar.filters": "Wyciszone słowa",
  "navigation_bar.follow_requests": "Prośby o obserwowanie",
  "navigation_bar.followed_tags": "Obserwowane hasztagi",
  "navigation_bar.follows_and_followers": "Obserwowani i obserwujący",
  "navigation_bar.import_export": "Import i eksport",
  "navigation_bar.lists": "Listy",
  "navigation_bar.live_feed_local": "Kanał na żywo (lokalny)",
  "navigation_bar.live_feed_public": "Kanał na żywo (publiczny)",
  "navigation_bar.logout": "Wyloguj",
  "navigation_bar.moderation": "Moderacja",
  "navigation_bar.more": "Więcej",
  "navigation_bar.mutes": "Wyciszeni",
  "navigation_bar.opened_in_classic_interface": "Wpisy, konta i inne określone strony są domyślnie otwierane w widoku klasycznym.",
  "navigation_bar.preferences": "Ustawienia",
  "navigation_bar.privacy_and_reach": "Prywatność i zasięg",
  "navigation_bar.search": "Szukaj",
  "navigation_bar.search_trends": "Szukaj / Na czasie",
  "navigation_panel.collapse_followed_tags": "Zwiń menu obserwowanych hashtagów",
  "navigation_panel.collapse_lists": "Zwiń menu listy",
  "navigation_panel.expand_followed_tags": "Rozwiń menu obserwowanych hashtagów",
  "navigation_panel.expand_lists": "Rozwiń menu listy",
  "not_signed_in_indicator.not_signed_in": "Zaloguj się, aby uzyskać dostęp.",
  "notification.admin.report": "{name} zgłosił {target}",
  "notification.admin.report_account": "{name} zgłosił(a) {count, plural, one {1 wpis} few {# wpisy} other {# wpisów}} z {target} w kategorii {category}",
  "notification.admin.report_account_other": "{name} zgłosił(a) {count, plural, one {1 wpis} few {# wpisy} other {# wpisów}} z {target}",
  "notification.admin.report_statuses": "{name} zgłosił(a) {target} w kategorii {category}",
  "notification.admin.report_statuses_other": "{name} zgłosił(a) {target}",
  "notification.admin.sign_up": "{name} rejestruje się",
  "notification.admin.sign_up.name_and_others": "{name} i {count, plural, one {# inna osoba} few {# inne osoby}  other {# innych osób}} zarejestrowali się",
  "notification.annual_report.message": "Twój {year} #Wrapstodon jest już dostępny! Zobacz swoje podsumowanie roku i niezapomniane chwile na Mastodon!",
  "notification.annual_report.view": "Zobacz #Wrapstodon",
  "notification.favourite": "{name} lubi twój wpis",
  "notification.favourite.name_and_others_with_link": "{name} i <a>{count, plural, one {# inna osoba} few {# inne osoby} other {# innych osób}}</a> lubią twój wpis",
  "notification.favourite_pm": "{name} lubi wzmiankę bezpośrednią od ciebie",
  "notification.favourite_pm.name_and_others_with_link": "{name} i <a>{count, plural, one {# inna osoba} few {# inne osoby} other {# innych osób}}</a> lubią wzmiankę bezpośrednią od ciebie",
  "notification.follow": "{name} obserwuje cię",
  "notification.follow.name_and_others": "{name} i <a>{count, plural, one {# inna osoba} few {# inne osoby} other {# innych osób}}</a> zaobserwowali cię",
  "notification.follow_request": "{name} chce cię zaobserwować",
  "notification.follow_request.name_and_others": "{name} i {count, plural, one {# inna osoba} few {# inne osoby} other {# innych osób}} chcą cię zaobserwować",
  "notification.label.mention": "Wzmianka",
  "notification.label.private_mention": "Wzmianka bezpośrednia",
  "notification.label.private_reply": "Komentarz bezpośredni",
  "notification.label.quote": "{name} cytował twój post",
  "notification.label.reply": "Komentarz",
  "notification.mention": "Wzmianka",
  "notification.mentioned_you": "{name} wzmiankuje cię",
  "notification.moderation-warning.learn_more": "Dowiedz się więcej",
  "notification.moderation_warning": "Otrzymano ostrzeżenie",
  "notification.moderation_warning.action_delete_statuses": "Usunięto niektóre z twoich wpisów.",
  "notification.moderation_warning.action_disable": "Twoje konto zostało wyłączone.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Niektóre z twoich wpisów zostały oznaczone jako wrażliwe.",
  "notification.moderation_warning.action_none": "Twoje konto otrzymało ostrzeżenie.",
  "notification.moderation_warning.action_sensitive": "Twoje wpisy będą od teraz oznaczane jako wrażliwe.",
  "notification.moderation_warning.action_silence": "Twoje konto zostało ograniczone.",
  "notification.moderation_warning.action_suspend": "Twoje konto zostało zawieszone.",
  "notification.own_poll": "Twoja ankieta została zakończona",
  "notification.poll": "Zakończyła się ankieta, w której głosowano",
  "notification.quoted_update": "{name} edytował post, który cytowałeś",
  "notification.reblog": "Twój post został podbity przez {name}",
  "notification.reblog.name_and_others_with_link": "{name} i <a>{count, plural, one {# inna osoba} few {# inne osoby} other {# innych osób}}</a> podbili twój wpis",
  "notification.relationships_severance_event": "Utracono połączenie z {name}",
  "notification.relationships_severance_event.account_suspension": "Administrator {from} zawiesił {target}, co oznacza, że nie możesz już otrzymywać aktualności ani wchodzić w interakcje z tą osobą.",
  "notification.relationships_severance_event.domain_block": "Administrator {from} zablokował {target}, w tym {followersCount} twoich obserwujących i {followingCount, plural, one {# konto} few {# konta} other {# kont}}, które obserwujesz.",
  "notification.relationships_severance_event.learn_more": "Dowiedz się więcej",
  "notification.relationships_severance_event.user_domain_block": "Zablokowano {target}, w tym {followersCount} Twoich obserwujących i {followingCount, plural, one {# konto} few {# konta} other {# kont}}, które obserwujesz.",
  "notification.status": "{name} opublikował(a) nowy wpis",
  "notification.update": "{name} edytował(a) post",
  "notification_requests.accept": "Akceptuj",
  "notification_requests.accept_multiple": "Przyjmij {count, plural, one {# prośbę} few {# prośby} other {# próśb}}...",
  "notification_requests.confirm_accept_multiple.button": "Przyjmij {count, plural, one {# prośbę} few {# prośby} other {# próśb}}",
  "notification_requests.confirm_accept_multiple.message": "Zamierzasz przyjąć {count, plural, one {# prośbę} few {# prośby} other {# próśb}}. Czy na pewno chcesz kontynuować?",
  "notification_requests.confirm_accept_multiple.title": "Przyjąć prośby?",
  "notification_requests.confirm_dismiss_multiple.button": "Odrzuć {count, plural, one {# prośbę} few {# prośby} other {# próśb}}",
  "notification_requests.confirm_dismiss_multiple.message": "Zamierzasz odrzucić {count, plural, one {# prośbę} few {# prośby} other {# próśb}}. Stracisz do {count, plural, one {tego}  other {tego}} łatwy dostęp. Czy na pewno chcesz kontynuować?",
  "notification_requests.confirm_dismiss_multiple.title": "Odrzucić prośbę?",
  "notification_requests.dismiss": "Odrzuć",
  "notification_requests.dismiss_multiple": "Odrzuć {count, plural, one {# prośbę} few {# prośby} other {# próśb}}...",
  "notification_requests.edit_selection": "Edytuj",
  "notification_requests.exit_selection": "Gotowe",
  "notification_requests.explainer_for_limited_account": "Powiadomienia z tego konta zostały odfiltrowane, ponieważ konto zostało ograniczone przez moderatora.",
  "notification_requests.explainer_for_limited_remote_account": "Powiadomienia z tego konta zostały odfiltrowane, ponieważ konto lub serwer zostały ograniczone przez moderatora.",
  "notification_requests.maximize": "Maksymalizuj",
  "notification_requests.minimize_banner": "Minimalizuj odfiltrowane powiadomienia",
  "notification_requests.notifications_from": "Powiadomienia od {name}",
  "notification_requests.title": "Odfiltrowane powiadomienia",
  "notification_requests.view": "Wyświetl powiadomienia",
  "notifications.clear": "Wyczyść powiadomienia",
  "notifications.clear_confirmation": "Czy na pewno chcesz trwale wyczyścić wszystkie powiadomienia?",
  "notifications.clear_title": "Wyczyścić powiadomienia?",
  "notifications.column_settings.admin.report": "Nowe zgłoszenia:",
  "notifications.column_settings.admin.sign_up": "Nowo zarejestrowani:",
  "notifications.column_settings.alert": "Powiadomienia na pulpicie",
  "notifications.column_settings.collections": "Kolekcje:",
  "notifications.column_settings.favourite": "Polubione:",
  "notifications.column_settings.filter_bar.advanced": "Wyświetl wszystkie kategorie",
  "notifications.column_settings.filter_bar.category": "Szybkie filtrowanie",
  "notifications.column_settings.follow": "Nowi obserwujący:",
  "notifications.column_settings.follow_request": "Nowe prośby o obserwowanie:",
  "notifications.column_settings.group": "Grupuj",
  "notifications.column_settings.mention": "Wzmianki:",
  "notifications.column_settings.poll": "Wyniki ankiety:",
  "notifications.column_settings.push": "Powiadomienia push",
  "notifications.column_settings.quote": "Cytaty:",
  "notifications.column_settings.reblog": "Podbicia:",
  "notifications.column_settings.show": "Pokaż w kolumnie",
  "notifications.column_settings.sound": "Odtwarzaj dźwięk",
  "notifications.column_settings.status": "Nowe wpisy:",
  "notifications.column_settings.unread_notifications.category": "Nieprzeczytane powiadomienia",
  "notifications.column_settings.unread_notifications.highlight": "Wyróżnij nieprzeczytane powiadomienia",
  "notifications.column_settings.update": "Edycje:",
  "notifications.filter.all": "Wszystkie",
  "notifications.filter.boosts": "Podbicia",
  "notifications.filter.collections": "Kolekcje",
  "notifications.filter.favourites": "Polubione",
  "notifications.filter.follows": "Obserwacje",
  "notifications.filter.mentions": "Wzmianki",
  "notifications.filter.polls": "Wyniki ankiety",
  "notifications.filter.statuses": "Aktualności od obserwowanych",
  "notifications.grant_permission": "Przyznaj uprawnienia.",
  "notifications.group": "{count, number} {count, plural, one {powiadomienie} few {powiadomienia} many {powiadomień} more {powiadomień}}",
  "notifications.mark_as_read": "Oznacz wszystkie powiadomienia jako przeczytane",
  "notifications.permission_denied": "Powiadomienia na pulpicie są niedostępne z powodu wcześniejszego braku zgody",
  "notifications.permission_denied_alert": "Nie można włączyć powiadomień na pulpicie, ponieważ wcześniej nie udzielono zgody",
  "notifications.permission_required": "Powiadomienia na pulpicie są niedostępne, ponieważ nie przyznano wymaganych uprawnień.",
  "notifications.policy.accept": "Akceptuj",
  "notifications.policy.accept_hint": "Pokazuj w powiadomieniach",
  "notifications.policy.drop": "Ignoruj",
  "notifications.policy.drop_hint": "Usuń trwale",
  "notifications.policy.filter": "Odfiltruj",
  "notifications.policy.filter_hint": "Przenieś do odfiltrowanych powiadomień",
  "notifications.policy.filter_limited_accounts_hint": "Ograniczonych przez moderatorów serwera",
  "notifications.policy.filter_limited_accounts_title": "Kont zmoderowanych",
  "notifications.policy.filter_new_accounts.hint": "Utworzonych w ciągu {days, plural, one {ostatniego dnia} other {ostatnich # dni}}",
  "notifications.policy.filter_new_accounts_title": "Nowych kont",
  "notifications.policy.filter_not_followers_hint": "Uwzględniając osoby, które obserwują cię krócej niż {days, plural, one {# dzień} other {# dni}}",
  "notifications.policy.filter_not_followers_title": "Osób, które Cię nie obserwują",
  "notifications.policy.filter_not_following_hint": "Do momentu zatwierdzenia",
  "notifications.policy.filter_not_following_title": "Osób, których nie obserwujesz",
  "notifications.policy.filter_private_mentions_hint": "Odfiltrowane, chyba że są odpowiedzią na wzmiankę od ciebie lub obserwujesz nadawcę",
  "notifications.policy.filter_private_mentions_title": "Niechcianych wzmianek bezpośrednich",
  "notifications.policy.title": "Zarządzaj powiadomieniami od…",
  "notifications_permission_banner.enable": "Włącz powiadomienia na pulpicie",
  "notifications_permission_banner.how_to_control": "Aby otrzymywać powiadomienia, gdy Mastodon nie jest otwarty, włącz powiadomienia na pulpicie. Możesz wybrać, które dokładnie typy interakcji generują powiadomienia na pulpicie za pomocą przycisku {icon} powyżej po ich włączeniu.",
  "notifications_permission_banner.title": "Nigdy niczego nie przegapisz",
  "onboarding.follows.back": "Wróć",
  "onboarding.follows.empty": "Niestety, w tej chwili nie można nic wyświetlić. Możesz użyć wyszukiwania lub przeglądać stronę główną, aby znaleźć osoby, które chcesz obserwować, albo spróbuj ponownie później.",
  "onboarding.follows.next": "Następnie: ustaw swój profil",
  "onboarding.follows.search": "Szukaj",
  "onboarding.follows.title": "Zaobserwuj kogoś, aby zacząć",
  "onboarding.profile.discoverable": "Spraw, by mój profil był widoczny",
  "onboarding.profile.discoverable_hint": "Gdy zdecydujesz się na włączenie widoczności na Mastodon, twoje wpisy mogą pojawiać się w wynikach wyszukiwania i aktualnościach, a twój profil może być polecany osobom o podobnych zainteresowaniach.",
  "onboarding.profile.display_name": "Wyświetlana nazwa",
  "onboarding.profile.display_name_hint": "Twoje imię lub pseudonim…",
  "onboarding.profile.finish": "Zakończ",
  "onboarding.profile.note": "Opis",
  "onboarding.profile.note_hint": "Możesz @wzmiankować innych lub dodawać #hashtagi…",
  "onboarding.profile.title": "Ustawienia profilu",
  "onboarding.profile.upload_avatar": "Dodaj zdjęcie profilowe",
  "onboarding.profile.upload_header": "Dodaj baner",
  "password_confirmation.exceeds_maxlength": "Długość potwierdzonego hasła przekracza maksymalną długość hasła",
  "password_confirmation.mismatching": "Hasła nie są takie same",
  "picture_in_picture.restore": "Powrót",
  "poll.closed": "Zamknięte",
  "poll.refresh": "Odśwież",
  "poll.reveal": "Zobacz wyniki",
  "poll.total_people": "{count, plural, one {# osoba} few {# osoby} many {# osób} other {# osób}}",
  "poll.total_votes": "{count, plural, one {# głos} few {# głosy} many {# głosów} other {# głosów}}",
  "poll.vote": "Głosuj",
  "poll.voted": "Wybrano tę odpowiedź",
  "poll.votes": "{votes, plural, one {# głos} few {# głosy} many {# głosów} other {# głosów}}",
  "poll_button.add_poll": "Dodaj ankietę",
  "poll_button.remove_poll": "Usuń ankietę",
  "privacy.change": "Dostosuj widoczność wpisów",
  "privacy.direct.long": "Wszyscy wzmiankowani w tym wpisie",
  "privacy.direct.short": "Wzmianka bezpośrednia",
  "privacy.private.long": "Tylko obserwujący",
  "privacy.private.short": "Obserwujący",
  "privacy.public.long": "Każdy na i poza Mastodon",
  "privacy.public.short": "Publiczny",
  "privacy.quote.anyone": "{visibility}, każdy może cytować",
  "privacy.quote.disabled": "{visibility}, cytaty wyłączone",
  "privacy.quote.limited": "{visibility}, cytaty ograniczone",
  "privacy.unlisted.additional": "Dostępny podobnie jak wpis publiczny, ale nie będzie widoczny w aktualnościach, hashtagach ani wyszukiwarce Mastodon, nawet jeśli twoje konto jest widoczne.",
  "privacy.unlisted.long": "Ukryte w wynikach wyszukiwania Mastodona, trendach i publicznych osiach czasu",
  "privacy.unlisted.short": "Niewidoczny",
  "privacy_policy.last_updated": "Data ostatniej aktualizacji: {date}",
  "privacy_policy.title": "Polityka prywatności",
  "quote_error.edit": "Podczas edycji wpisu nie można dodawać cytatów.",
  "quote_error.poll": "W ankietach nie można cytować.",
  "quote_error.private_mentions": "Cytowanie nie jest dozwolone w przypadku wzmianek bezpośrednich.",
  "quote_error.quote": "Dozwolone jest tylko jedno cytowanie na raz.",
  "quote_error.unauthorized": "Nie masz uprawnień do cytowania tego wpisu.",
  "quote_error.upload": "Cytowanie nie jest dozwolone w przypadku załączników multimedialnych.",
  "recommended": "Zalecane",
  "refresh": "Odśwież",
  "regeneration_indicator.please_stand_by": "Proszę czekać.",
  "regeneration_indicator.preparing_your_home_feed": "Wczytywanie twojej osi czasu…",
  "relative_time.days": "{number} dni",
  "relative_time.full.days": "{number, plural, one {# dzień} few {# dni} many {# dni} other {# dni}} temu",
  "relative_time.full.hours": "{number, plural, one {# godzinę} few {# godziny} many {# godzin} other {# godzin}} temu",
  "relative_time.full.just_now": "przed chwilą",
  "relative_time.full.minutes": "{number, plural, one {# minutę} few {# minuty} many {# minut} other {# minut}} temu",
  "relative_time.full.seconds": "{number, plural, one {# sekundę} few {# sekundy} many {# sekund} other {# sekund}} temu",
  "relative_time.hours": "{number} godz.",
  "relative_time.just_now": "teraz",
  "relative_time.minutes": "{number} min.",
  "relative_time.seconds": "{number} s.",
  "relative_time.today": "dzisiaj",
  "remove_quote_hint.button_label": "Rozumiem",
  "remove_quote_hint.message": "Można to zrobić z poziomu menu opcji {icon}.",
  "remove_quote_hint.title": "Czy chcesz usunąć swój cytowany post?",
  "reply_indicator.attachments": "{count, plural, one {# załącznik} few {# załączniki} many {# załączników} other {# załączników}}",
  "reply_indicator.cancel": "Anuluj",
  "reply_indicator.poll": "Ankieta",
  "report.block": "Zablokuj",
  "report.block_explanation": "Nie zobaczysz wpisów tej osoby, a ona twoich, ani nie będzie mogła cię zaobserwować. Informacja o zablokowaniu będzie widoczna.",
  "report.categories.legal": "Prawne",
  "report.categories.other": "Inne",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Zawartość narusza co najmniej jedną zasadę serwera",
  "report.category.subtitle": "Wybierz najbardziej pasującą opcję",
  "report.category.title_account": "Powiedz, co się dzieje z tym profilem",
  "report.category.title_collection": "Powiedz, co się dzieje z tą kolekcją",
  "report.category.title_status": "Powiedz, co się dzieje z tym postem",
  "report.close": "Gotowe",
  "report.comment.title": "Czy jest coś jeszcze, co powinniśmy wiedzieć?",
  "report.forward": "Prześlij do {target}",
  "report.forward_hint": "Konto pochodzi z innego serwera. Czy chcesz również tam wysłać kopię zgłoszenia anonimowo?",
  "report.mute": "Wycisz",
  "report.mute_explanation": "Nie zobaczysz wpisów tej osoby, ale ona nadal będzie mogła cię obserwować i zobaczyć twoje wpisy. Informacja o wyciszeniu nie będzie widoczna.",
  "report.next": "Dalej",
  "report.placeholder": "Dodatkowe informacje",
  "report.reasons.dislike": "Nie podoba mi się to",
  "report.reasons.dislike_description": "Nie jest to coś, co chciałoby się zobaczyć",
  "report.reasons.legal": "To jest nielegalne",
  "report.reasons.legal_description": "Uważasz, że narusza to prawo twojego kraju lub kraju, w którym znajduje się serwer",
  "report.reasons.other": "Coś innego",
  "report.reasons.other_description": "Zgłoszenie nie pasuje do żadnej z pozostałych kategorii",
  "report.reasons.spam": "To spam",
  "report.reasons.spam_description": "Niebezpieczne linki, fałszywe zaangażowanie lub powtarzające się odpowiedzi",
  "report.reasons.violation": "Narusza to zasady serwera",
  "report.reasons.violation_description": "Zdajesz sobie sprawę, że narusza to szczególne zasady",
  "report.rules.subtitle": "Wybierz wszystkie pasujące",
  "report.rules.title": "Które zasady zostały złamane?",
  "report.statuses.subtitle": "Wybierz wszystkie pasujące",
  "report.statuses.title": "Czy są jakieś wpisy, które obrazują opisany w zgłoszeniu problem?",
  "report.submission_error": "Nie można przesłać zgłoszenia",
  "report.submission_error_details": "Sprawdź połączenie sieciowe i spróbuj ponownie później.",
  "report.submit": "Wyślij",
  "report.target": "Zgłaszanie {target}",
  "report.thanks.take_action": "Oto opcje, dzięki którym możesz kontrolować, co widzisz na Mastodon:",
  "report.thanks.take_action_actionable": "W trakcie jak będziemy się przyglądać tej sprawie, możesz podjąć akcje przeciwko @{name}:",
  "report.thanks.title": "Nie chcesz tego widzieć?",
  "report.thanks.title_actionable": "Dziękujemy za zgłoszenie. Przyjrzymy się tej sprawie.",
  "report.unfollow": "Przestań obserwować @{name}",
  "report.unfollow_explanation": "Obserwujesz to konto. Jeśli nie chcesz już widzieć postów z tego konta w swojej głównej osi czasu, przestań je obserwować.",
  "report_notification.attached_statuses": "{count, plural, one {{count} wpis} few {{count} wpisy} many {{counter} wpisów} other {{counter} wpisów}}",
  "report_notification.categories.legal": "Prawne",
  "report_notification.categories.legal_sentence": "treść nielegalna",
  "report_notification.categories.other": "Inne",
  "report_notification.categories.other_sentence": "inne",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Naruszenie zasad",
  "report_notification.categories.violation_sentence": "naruszenie zasad",
  "report_notification.open": "Otwórz zgłoszenie",
  "search.clear": "Wyczyść wyszukiwanie",
  "search.no_recent_searches": "Brak ostatnich wyszukiwań",
  "search.placeholder": "Szukaj",
  "search.quick_action.account_search": "Profile pasujące do {x}",
  "search.quick_action.go_to_account": "Przejdź do profilu {x}",
  "search.quick_action.go_to_hashtag": "Przejdź do hasztaga {x}",
  "search.quick_action.open_url": "Otwórz adres URL w Mastodonie",
  "search.quick_action.status_search": "Wpisy pasujące do {x}",
  "search.search_or_paste": "Wyszukaj lub wklej adres",
  "search_popout.full_text_search_disabled_message": "Niedostępne na {domain}.",
  "search_popout.full_text_search_logged_out_message": "Dostępne tylko po zalogowaniu.",
  "search_popout.language_code": "Kod języka wg ISO",
  "search_popout.options": "Opcje wyszukiwania",
  "search_popout.quick_actions": "Szybkie akcje",
  "search_popout.recent": "Ostatnie wyszukiwania",
  "search_popout.specific_date": "konkretna data",
  "search_popout.user": "użytkownik",
  "search_results.accounts": "Profile",
  "search_results.all": "Wszystkie",
  "search_results.collections": "Kolekcje",
  "search_results.hashtags": "Hasztagi",
  "search_results.no_results": "Brak wyników.",
  "search_results.no_search_yet": "Spróbuj poszukać wpisów, profili, lub hasztagów.",
  "search_results.see_all": "Pokaż wszystkie",
  "search_results.statuses": "Wpisy",
  "search_results.title": "Wyszukiwanie \"{q}\"",
  "server_banner.about_active_users": "Osoby korzystające z tego serwera w ciągu ostatnich 30 dni (Miesięcznie aktywni użytkownicy)",
  "server_banner.active_users": "aktywni użytkownicy",
  "server_banner.administered_by": "Zarządzana przez:",
  "server_banner.is_one_of_many": "{domain} jest jedną z wielu niezależnych serwerów Mastodon, których możesz użyć by uczestniczyć w fediwersum.",
  "server_banner.more_about_this_server": "Więcej o tym serwerze",
  "server_banner.server_stats": "Statystyki serwera:",
  "sign_in_banner.create_account": "Załóż konto",
  "sign_in_banner.follow_anyone": "Obserwuj kogokolwiek z fediwersum w kolejności chronologicznej. Bez algorytmów ani reklam.",
  "sign_in_banner.mastodon_is": "Mastodon to najlepszy sposób nadążania za bieżącymi zdarzeniami.",
  "sign_in_banner.sign_in": "Zaloguj się",
  "sign_in_banner.sso_redirect": "Zaloguj/zarejestruj się",
  "skip_links.skip_to_content": "Przejdź do głównej treści",
  "skip_links.skip_to_navigation": "Przejdź do głównej nawigacji",
  "status.admin_account": "Otwórz interfejs moderacyjny dla @{name}",
  "status.admin_domain": "Otwórz interfejs moderacyjny dla {domain}",
  "status.admin_status": "Otwórz ten wpis w interfejsie moderacyjnym",
  "status.all_disabled": "Podbicia i cytaty są wyłączone",
  "status.block": "Zablokuj @{name}",
  "status.bookmark": "Dodaj zakładkę",
  "status.cancel_reblog_private": "Cofnij podbicie",
  "status.cannot_edit": "Nie masz uprawnień, aby edytować ten post",
  "status.cannot_quote": "Nie można cytować tego wpisu",
  "status.cannot_reblog": "Ten wpis nie może zostać podbity",
  "status.contains_quote": "Zawiera cytat",
  "status.context.loading": "Wczytywanie kolejnych komentarzy",
  "status.context.loading_error": "Nie można wczytać nowych komentarzy",
  "status.context.loading_success": "Wczytano nowe komentarze",
  "status.context.more_replies_found": "Znaleziono więcej komentarzy",
  "status.context.retry": "Spróbuj ponownie",
  "status.context.show": "Pokaż",
  "status.continued_thread": "Ciąg dalszy wątku",
  "status.copy": "Skopiuj odnośnik do wpisu",
  "status.delete": "Usuń",
  "status.delete.success": "Post usunięty",
  "status.detailed_status": "Szczegółowy widok konwersacji",
  "status.direct": "Prywatna wzmianka @{name}",
  "status.direct_indicator": "Prywatna wzmianka",
  "status.edit": "Edytuj",
  "status.edited": "Ostatnio edytowane {date}",
  "status.edited_x_times": "Edytowano {count, plural, one {{count} raz} other {{count} razy}}",
  "status.embed": "Kod osadzenia",
  "status.favourite": "Dodaj do ulubionych",
  "status.favourites_count": "{count, plural, one {{counter} polubienie} few {{counter} polubienia} other {{counter} polubień}}",
  "status.filter": "Filtruj ten wpis",
  "status.history.created": "{name} utworzone {date}",
  "status.history.edited": "{name} edytowane {date}",
  "status.load_more": "Załaduj więcej",
  "status.media.open": "Kliknij, aby otworzyć",
  "status.media.show": "Kliknij, aby pokazać",
  "status.media_hidden": "Multimedia ukryte",
  "status.mention": "Wspomnij o @{name}",
  "status.more": "Więcej",
  "status.mute": "Wycisz @{name}",
  "status.mute_conversation": "Wycisz konwersację",
  "status.open": "Rozszerz ten wpis",
  "status.pin": "Przypnij do profilu",
  "status.public_only": "Ten post jest prywatny",
  "status.quote": "Cytuj",
  "status.quote.cancel": "Anuluj cytat",
  "status.quote_error.blocked_account_hint.title": "Ten post jest ukryty, ponieważ zablokowano użytkownika @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Ten wpis jest ukryty, ponieważ zablokowano {domain}.",
  "status.quote_error.filtered": "Ukryte z powodu jednego z Twoich filtrów",
  "status.quote_error.limited_account_hint.action": "Pokaż mimo wszystko",
  "status.quote_error.limited_account_hint.title": "To konto zostało ukryte przez moderatorów {domain}.",
  "status.quote_error.muted_account_hint.title": "Ten wpis jest ukryty, ponieważ wyciszono @{name}.",
  "status.quote_error.not_available": "Post niedostępny",
  "status.quote_error.pending_approval": "Post oczekujący",
  "status.quote_error.pending_approval_popout.body": "Na Mastodon możesz kontrolować, czy ktoś może cytować twoje wpisy. Ten wpis oczekuje na zatwierdzenie przez autora.",
  "status.quote_error.revoked": "Wpis został usunięty przez autora",
  "status.quote_followers_only": "Tylko obserwatorzy mogą cytować ten post",
  "status.quote_manual_review": "Autor zatwierdzi ręcznie",
  "status.quote_noun": "Cytuj",
  "status.quote_policy_change": "Zmień kto może cytować",
  "status.quote_post_author": "Zacytowano post @{name}",
  "status.quote_private": "Prywatne posty nie mogą być cytowane",
  "status.quotes.empty": "Nikt jeszcze nie zacytował tego wpisu. Gdy ktoś to zrobi, pojawi się on tutaj.",
  "status.quotes.local_other_disclaimer": "Cytaty odrzucone przez autora nie będą wyświetlane.",
  "status.quotes.remote_other_disclaimer": "Będą tutaj wyświetlane tylko cytaty z {domain}. Cytaty odrzucone przez autora nie będą wyświetlane.",
  "status.quotes_count": "{count, plural, one {{counter} cytat} few {{counter} cytaty} many {{counter} cytatów} other {{counter} cytatów}}",
  "status.read_more": "Czytaj dalej",
  "status.reblog": "Podbij",
  "status.reblog_or_quote": "Podbij lub cytuj",
  "status.reblog_private": "Udostępnij ponownie swoim obserwującym",
  "status.reblogged_by": "Podbite przez użytkownika {name}",
  "status.reblogs.empty": "Nikt nie podbił jeszcze tego wpisu. Gdy ktoś to zrobi, pojawi się tutaj.",
  "status.reblogs_count": "{count, plural, one {{counter} podbicie} few {{counter} podbicia} other {{counter} podbić}}",
  "status.redraft": "Usuń i przeredaguj",
  "status.remove_bookmark": "Usuń zakładkę",
  "status.remove_favourite": "Usuń z ulubionych",
  "status.remove_quote": "Usuń",
  "status.replied_in_thread": "Odpowiedź w wątku",
  "status.replied_to": "Odpowiedziano użytkownikowi {name}",
  "status.reply": "Odpowiedz",
  "status.replyAll": "Odpowiedz na wątek",
  "status.report": "Zgłoś @{name}",
  "status.request_quote": "Poproś o możliwość cytowania",
  "status.revoke_quote": "Usuń mój wpis z postu @{name}",
  "status.sensitive_warning": "Wrażliwa zawartość",
  "status.share": "Udostępnij",
  "status.show_less_all": "Zwiń wszystkie",
  "status.show_more_all": "Rozwiń wszystkie",
  "status.show_original": "Pokaż oryginał",
  "status.title.with_attachments": "{user} opublikował(a) {attachmentCount, plural, one {załącznik} few {{attachmentCount} załączniki} other {{attachmentCount} załączników}}",
  "status.translate": "Przetłumacz",
  "status.translated_from_with": "Przetłumaczono z {lang} przy użyciu {provider}",
  "status.uncached_media_warning": "Podgląd jest niedostępny",
  "status.unmute_conversation": "Cofnij wyciszenie konwersacji",
  "status.unpin": "Odepnij z profilu",
  "subscribed_languages.lead": "Tylko posty w wybranych językach pojawią się na Twojej osi czasu po zmianie. Nie wybieraj żadnego języka aby otrzymywać posty we wszystkich językach.",
  "subscribed_languages.save": "Zapisz zmiany",
  "subscribed_languages.target": "Zmień subskrybowane języki dla {target}",
  "tabs_bar.home": "Strona główna",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Powiadomienia",
  "tabs_bar.publish": "Nowy post",
  "tabs_bar.quick_links": "Szybki dostęp",
  "tabs_bar.search": "Szukaj",
  "tag.remove": "Usuń",
  "terms_of_service.effective_as_of": "Obowiązuje od {date}",
  "terms_of_service.title": "Warunki korzystania z usługi",
  "terms_of_service.upcoming_changes_on": "Nadchodzące zmiany od {date}",
  "time_remaining.days": "{number, plural, one {Pozostał # dzień} few {Pozostały # dni} many {Pozostało # dni} other {Pozostało # dni}}",
  "time_remaining.hours": "{number, plural, one {Pozostała # godzina} few {Pozostały # godziny} many {Pozostało # godzin} other {Pozostało # godzin}}",
  "time_remaining.minutes": "{number, plural, one {Pozostała # minuta} few {Pozostały # minuty} many {Pozostało # minut} other {Pozostało # minut}}",
  "time_remaining.moments": "Pozostała chwila",
  "time_remaining.seconds": "{number, plural, one {Pozostała # sekunda} few {Pozostały # sekundy} many {Pozostało # sekund} other {Pozostało # sekund}}",
  "trends.counter_by_accounts": "{count, plural, one {jedna osoba} few {{count} osoby} many {{count} osób} other {{counter} ludzie}} w ciągu {days, plural, one {ostatniego dnia} other {ostatnich {days} dni}}",
  "trends.trending_now": "Popularne teraz",
  "ui.beforeunload": "Utracisz tworzony wpis, jeżeli opuścisz Mastodona.",
  "units.short.billion": "{count} mld",
  "units.short.million": "{count} mln",
  "units.short.thousand": "{count} tys.",
  "upload_area.title": "Przeciągnij i upuść aby wysłać",
  "upload_button.label": "Dodaj zdjęcia, filmy lub audio",
  "upload_error.limit": "Przekroczono limit plików do wysłania.",
  "upload_error.poll": "Dołączanie plików nie dozwolone z głosowaniami.",
  "upload_error.quote": "Dołączanie plików nie jest pozwolone z cytatami.",
  "upload_form.drag_and_drop.instructions": "Naciśnij spację lub enter żeby podnieść załącznik. Podczas przeciągania, strzałki przesuwają załącznik. Naciśnięcie spacji lub entera upuści załącznik w nowym miejscu, a escape anuluje przesuwanie.",
  "upload_form.drag_and_drop.on_drag_cancel": "Przesuwanie anulowane. Załącznik {item} upuszczony.",
  "upload_form.drag_and_drop.on_drag_end": "Upuszczono załącznik {item}.",
  "upload_form.drag_and_drop.on_drag_over": "Przesunięto załącznik {item}.",
  "upload_form.drag_and_drop.on_drag_start": "Podniesiono załącznik {item}.",
  "upload_form.edit": "Edytuj",
  "upload_progress.label": "Wysyłanie…",
  "upload_progress.processing": "Przetwarzanie…",
  "username.taken": "Ta nazwa użytkownika jest już zajęta. Wybierz inną",
  "video.close": "Zamknij film",
  "video.download": "Pobierz plik",
  "video.exit_fullscreen": "Opuść tryb pełnoekranowy",
  "video.expand": "Rozszerz film",
  "video.fullscreen": "Pełny ekran",
  "video.hide": "Ukryj film",
  "video.mute": "Wycisz",
  "video.pause": "Pauzuj",
  "video.play": "Odtwórz",
  "video.skip_backward": "Skocz do tyłu",
  "video.skip_forward": "Skocz do przodu",
  "video.unmute": "Wyłącz wyciszenie",
  "video.volume_down": "Zmniejsz głośność",
  "video.volume_up": "Zwiększ głośność",
  "visibility_modal.button_title": "Ustaw widoczność",
  "visibility_modal.direct_quote_warning.text": "Jeśli zapiszesz bieżące ustawienia, osadzony cytat zostanie zamieniony na link.",
  "visibility_modal.direct_quote_warning.title": "Cytaty nie mogą być osadzane we wzmiankach prywatnych",
  "visibility_modal.header": "Widoczność i interakcja",
  "visibility_modal.helper.direct_quoting": "Prywatne wzmianki opublikowane na Mastodonie nie mogą być cytowane przez inne osoby.",
  "visibility_modal.helper.privacy_editing": "Widoczność nie może być zmieniona po opublikowaniu wpisu.",
  "visibility_modal.helper.privacy_private_self_quote": "Cytaty z prywatnych wpisów nie mogą być publiczne.",
  "visibility_modal.helper.private_quoting": "Wpisy publikowane na Mastodonie wyłącznie dla obserwujących nie mogą być cytowane przez inne osoby.",
  "visibility_modal.helper.unlisted_quoting": "Kiedy ktoś cytuje twoje wpisy, będą one również ukryte na popularnych osiach czasu.",
  "visibility_modal.instructions": "Kontroluj, kto może wchodzić w interakcję z tym wpisem. Możesz również zastosować ustawienia do wszystkich przyszłych wpisów, przechodząc do <link>Preferencje > Domyślne ustawienia publikowania</link>.",
  "visibility_modal.privacy_label": "Widoczność",
  "visibility_modal.quote_followers": "Tylko dla obserwujących",
  "visibility_modal.quote_label": "Kto może cytować",
  "visibility_modal.quote_nobody": "Tylko ja",
  "visibility_modal.quote_public": "Każdy",
  "visibility_modal.save": "Zapisz"
}
